/* Custom lanyard designer (2026-10-13). Mounted by sections/custom-lanyard-designer.liquid.
   Draws the lanyard on canvas: the print strip is built flat (it IS the print layout), then
   bent slice by slice onto the hanging loop, with the real hardware photos composited on. */
(function () {
  'use strict';
  var CFG = window.CL_CONFIG;
  if (!CFG || !CFG.variants || !CFG.variants.length) return;

  /* ---------- catalog (the live FPD lanyard setup, 2026-10-13) ---------- */
  // Grouped by color family, families in order of custom lanyard orders (12 months): blues 51,
  // black 49, reds 23, greens 21, yellows 17, oranges 11, white 9, purples 8, teals 6, gray 6, pinks 2;
  // most-ordered shade first, then its neighbors. Black then white lead the row (Patrick, 2026-10-13), then the blues; the defaults are the
  // first swatch of each row: black lanyard, white ink.
  var LANYARD_COLORS = [
    ['Black', '#222222'], ['White', '#FFFFFF'], ['Navy Blue 289C', '#0C2340'], ['Dark Blue 282C', '#041E42'],
    ['Royal Blue 294C', '#002F6C'], ['Blue 072C', '#10069F'], ['Aqua Blue 801C', '#009ACE'], ['Pale Blue 292C', '#69B3E7'], ['Sky Blue 635C', '#A4DBE8'],
    ['Red 200C', '#BA0C2F'], ['Bright Red 186C', '#C8102E'], ['Rich Red 187C', '#A6192E'], ['Maroon 195C', '#782F40'],
    ['Green 348C', '#00843D'], ['Forest 5535C', '#183028'], ['Bright Green 802C', '#44D62C'], ['Lime Green 375C', '#97D700'],
    ['Yellow 115C', '#FDDA24'], ['Bright Yellow 109C', '#FFD100'], ['Mustard Yellow 116C', '#FFCD00'], ['Burnt Yellow 1235C', '#FFB81C'],
    ['Neon Yellow 809C', '#E3E829'], ['Orange 151C', '#FF8200'], ['Burnt Orange 1495C', '#FF8F1C'],
    ['Purple 268C', '#582C83'], ['Vivid Purple 814C', '#8A69D4'], ['Teal 316C', '#004851'], ['Blue Green 322C', '#007377'],
    ['Royal Blue 7686C', '#1D4F91'], ['Cool Grey 7', '#A3A19E'], ['Rubine Red C', '#CE0058'], ['Hot Pink 806C', '#FF3EB5'], ['Pink 211C', '#F57EB6']
  ];
  // White and black first (the usual inks), then the same families as the lanyard colors.
  var INK_COLORS = [
    ['White', '#FFFFFF'], ['Black', '#000000'], ['Navy Blue 289C', '#0C2340'], ['Dark Blue 282C', '#041E42'],
    ['Reflex Blue C', '#001489'], ['Royal Blue 294C', '#002F6C'], ['Blue 072C', '#10069F'], ['Aqua Blue 801C', '#009ACE'],
    ['Pale Blue 292C', '#69B3E7'], ['Red 200C', '#BA0C2F'], ['Bright Red 186C', '#C8102E'], ['Rich Red 187C', '#A6192E'],
    ['Maroon 195C', '#782F40'], ['Green 348C', '#00843D'], ['Forest 5535C', '#183028'], ['Bright Green 802C', '#44D62C'],
    ['Lime Green 375C', '#97D700'], ['Yellow 115C', '#FDDA24'], ['Bright Yellow 109C', '#FFD100'], ['Mustard Yellow 116C', '#FFCD00'],
    ['Burnt Yellow 1235C', '#FFB81C'], ['Neon Yellow 809C', '#E3E829'], ['Orange 151C', '#FF8200'], ['Burnt Orange 1495C', '#FF8F1C'],
    ['Purple 268C', '#582C83'], ['Vivid Purple 814C', '#8A69D4'], ['Teal 316C', '#004851'], ['Teal 321C', '#008C95'],
    ['Blue Green 322C', '#007377'], ['Royal Blue 7686C', '#1D4F91'], ['Cool Grey 7', '#A3A19E'], ['Rubine Red C', '#CE0058'], ['Hot Pink 806C', '#FF3EB5'],
    ['Pink 211C', '#F57EB6']
  ];
  // code, variant option value (FPD name), add-on each, ref width in inches, ref width in image px, main.
  // Scale: the strap passes through each clip's top ring, so the ring (or the whole part for rings,
  // reels and buckles) is drawn at its real width: 5/8" D-rings ~0.8" outside, split rings 1",
  // reel 1.25". Ref px measured from the trimmed cl-*.png. main = sold in the last 12
  // months (sales/SALES-ANALYSIS.md); the rest sit behind "Show more".
  // Order = 5/8" silk screen sales, last 12 months (orders): swivel hook 21, badge reel combo 14,
  // trigger snap 6, wide plastic hook 5, split ring 4, J-hook 3, bulldog 2, narrow plastic hook 1,
  // buckles 1 each; the rest never sold on this lanyard. The page's section settings pick how many
  // show before "Show more" (focused pages) or show all of them (the full designer).
  var CLIPS = [
    ['sh', 'Nickel-Plated Swivel Hook', 0, 0.80, 68], ['rc', 'Badge Reel Combo', 0.98, 1.25, 176],
    ['ts', 'Nickel-Plated Steel Trigger Snap Hook', 0, 0.85, 97],
    // after the top 3: our factory's 2026 production list (Patrick 2026-10-23), similar clips side by side, buckles last.
    // Standard (no charge at the factory): swivel hook, swivel bulldog, bulldog, split ring, USB holder. Their small
    // extras (plastic hooks, trigger snap, vinyl strap, J-hook: $0.04-0.07) are included too; lobster claw, badge
    // reel and the detachable buckles keep an add-on.
    ['pwk', 'Wide Plastic Hook Black', 0, 1.0, 94], ['pnk', 'Narrow Plastic Hook Black', 0, 0.7, 73], ['pj', 'Plastic J-Hook', 0, 0.85, 104],
    ['sr', 'Nickel-Plated Split Ring', 0, 1.0, 142], ['sv', 'Nickel-Plated Split Ring with Clear Vinyl Strap Clip', 0, 1.0, 130],
    ['sb', 'Nickel-Plated Swivel Bulldog Clip', 0, 0.75, 59], ['bc', 'Nickel-Plated Bulldog Clip', 0, 0.75, 92],
    ['usb', 'USB/Flash Drive Holder', 0, 0.35, 39], ['lc', 'Nickel-Plated Lobster Claw', 0.32, 0.95, 120],
    ['dh', 'Detachable Buckle with Swivel Hook', 0.45, 0.9, 122], ['dt', 'Detachable Buckle with Trigger Snap Hook', 0.45, 0.9, 120],
    ['db', 'Detachable Buckle with Bulldog Clip', 0.45, 0.9, 97], ['dr', 'Detachable Buckle with Split Ring', 0.45, 0.9, 97],
    ['dlc', 'Detachable Buckle with Lobster Claw', 0.45, 0.9, 120], ['dx', 'Detachable Buckle with 3" Extension', 0.45, 0.5, 61]
  ];
  var FULL = CFG.mode === 'full';
  var MAIN_CLIPS = String(CFG.mainClips || 'sh,rc,ts').split(',').map(function (x) { return x.trim(); });
  function isMain(code) { return MAIN_CLIPS.indexOf(code) >= 0; }
  var BREAKAWAYS = [['none', 'None', null], ['black', 'Black', 'brk-black'], ['white', 'White', 'brk-white'], ['clip', 'Clip style', 'brk-clip']];
  var FINISHES = [['Sewn', null], ['Crimp', 'fin-crimp']]; // sewn standard, crimp optional; bead dropped (Patrick, 2026-10-13)
  var FONTS = ['Arial', 'Futura Bold', 'Rockwell', 'Verdana', 'Minion Pro Bold', 'Bodoni Bold', 'Garamond Bold'];
  var FONT_STACK = { 'Arial': 'Arial, "Liberation Sans", Helvetica, sans-serif' };
  var ADD_BREAKAWAY = 0; // breakaway is included in the price (Patrick, 2026-10-22: one fair price, few add-ons)
  function addBack() { var b = METHODS[method()] && METHODS[method()].back; return b == null ? 0 : b; }

  /* ---------- geometry ---------- */
  var PPI = 64;                 // flat strip, px per inch
  var LEN_IN = 36, W_IN = 0.625; // W_IN follows the selected width
  var NOPRINT_END_IN = 1.0, BREAKAWAY_CLEAR_IN = 0.75, SAFE_IN = 1 / 16;
  var STRIP_W = Math.round(LEN_IN * PPI), STRIP_H = Math.round(W_IN * PPI); // STRIP_H follows the width
  
  // Width x print method. Each combination is its own (hidden) product whose variants are the part
  // numbers; the full designer swaps between them in place. Prices: TIER_TABLE below
  // (100-piece base at each break; add-ons stay flat).
  var METHODS = { SS: { name: 'Silk screen', sub: '1 to 3 ink colors', back: 0.25, label: 'Silk screen' },
                  DS: { name: 'Dye sublimation', sub: 'Full color', back: 0, label: 'Full color dye sublimation' },
                  WV: { name: 'Woven', sub: 'Thread, raised look', back: null, label: 'Woven' } };
  var WIDTHS = [['38', 0.375, '3/8"'], ['58', 0.625, '5/8"'], ['34', 0.75, '3/4"'], ['100', 1, '1"']];
  var TIER_Q = [100, 200, 500, 1000, 2500, 5000, 10000];
  // Price per lanyard at each break, setup, breakaway and up to 3 ink/thread colors included (2026-10-25).
  // From specialistid-ops/products/custom-lanyards/costs/price_matrix.py: at least 30% margin on our main
  // production cost and 15% on the backup in the worst case, at or under the competitor median where that
  // allows. Add-ons stay flat across breaks.
  var TIER_TABLE = {
    SS38: [2.46, 2.01, 1.45, 1.29, 1.00, 0.95, 0.94], SS58: [2.57, 2.17, 1.53, 1.36, 1.09, 0.99, 0.99],
    SS34: [2.73, 2.27, 1.59, 1.40, 1.13, 1.04, 1.03], SS100: [2.81, 2.36, 1.66, 1.48, 1.21, 1.15, 1.12],
    DS38: [3.05, 2.49, 2.14, 1.83, 1.10, 1.00, 0.90], DS58: [3.36, 2.68, 2.42, 2.00, 1.27, 1.04, 0.94],
    DS34: [3.36, 2.80, 2.52, 2.00, 1.27, 1.12, 1.00], DS100: [3.45, 2.92, 2.65, 2.11, 1.38, 1.19, 1.05],
    WV38: [3.07, 2.46, 1.53, 1.45, 1.10, 1.02, 0.95], WV58: [3.26, 2.70, 1.66, 1.52, 1.15, 1.05, 0.99],
    WV34: [3.41, 2.80, 1.75, 1.58, 1.22, 1.10, 1.02]
  };
  // the 12 webbing colors woven lanyards come in (FPD avTable)
  // Badge reel combo: the reel housing colors we stock (2138-700X, Patrick 2026-10-13). Default follows the lanyard.
  var REEL_COLORS = [['Black', '#1E1E1E'], ['White', '#EDEDED'], ['Navy Blue', '#14274E'], ['Royal Blue', '#1F3FA3'], ['Red', '#C8102E'],
    ['Maroon', '#782F40'], ['Orange', '#FF8200'], ['Yellow', '#FFD100'], ['Green', '#00843D']];
  // The factory's 13 standard colors (2026 sheet): the only lanyard colors on silk screen and woven (any other
  // color is a $30 dye charge, so sales handles it), and woven's thread colors. Inks are any Pantone; dye sub any color.
  var STD_COLORS = ['White', 'Black', 'Teal 316C', 'Royal Blue 294C', 'Royal Blue 7686C', 'Purple 268C', 'Yellow 115C', 'Orange 151C', 'Red 200C', 'Navy Blue 289C', 'Maroon 195C', 'Green 348C', 'Forest 5535C'];
  var WOVEN_COLORS = STD_COLORS;
  var ENGINES = {};
  String(CFG.engines || '').split(',').forEach(function (p) { var a = p.split(':'); if (a[1]) ENGINES[a[0].trim()] = a[1].trim(); });
  var engineCache = {};
  function method() { return S.key.replace(/\d+$/, ''); }
  function widthCode() { return S.key.replace(/^[A-Z]+/, ''); }
  function widthIn() { for (var i = 0; i < WIDTHS.length; i++) if (WIDTHS[i][0] === widthCode()) return WIDTHS[i][1]; return 0.625; }
  function widthLabel() { for (var i = 0; i < WIDTHS.length; i++) if (WIDTHS[i][0] === widthCode()) return WIDTHS[i][2]; return '5/8"'; }
  function tiersFor(key) { var t = TIER_TABLE[key]; return t ? TIER_Q.map(function (q, i) { return { q: q, base: t[i] }; }) : null; }
  var TIERS = String(CFG.tiers).split(',').map(function (p) { var a = p.split(':'); return { q: parseInt(a[0], 10), base: parseFloat(a[1]) }; })
    .filter(function (t) { return t.q > 0 && isFinite(t.base); }).sort(function (a, b) { return a.q - b.q; });

  /* ---------- state ---------- */
  var DEFAULT_TEXT = 'Your text here';
  var S = {
    path: 'design', altOpen: false, reelColor: null, color: 'Black', clip: CFG.defaultClip || 'sh', breakaway: CFG.defaultBreakaway || 'auto', finish: 'Sewn',
    view: { z: 1, x: 0, y: 0 },
    sides: 'front', // front | same | different
    key: CFG.key || 'SS58',
    side: 'front',  // which side the editor shows
    layout: 'continuous', spacing: 0.75, logoPos: 'between', // logo centered between text repeats: the most common custom layout
    d: { front: Object.assign(newDesign(), { text: DEFAULT_TEXT }), back: newDesign() },
    uploadFile: null, helpNotes: '', helpFiles: [],
    clipsOpen: false
  };
  function newDesign() { return { text: '', font: 'Arial', ink: 'White', logo: null, logoSrc: null, logoImg: null, logoInkList: null, prepKey: '' }; }

  var imgCache = {};
  function loadImg(src) {
    if (!src) return Promise.resolve(null);
    if (imgCache[src]) return imgCache[src];
    imgCache[src] = new Promise(function (res) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { res(i); }; i.onerror = function () { res(null); }; i.src = src; });
    return imgCache[src];
  }
  var fontsReady = {};
  function ensureFont(name) {
    if (!CFG.fonts[name] || fontsReady[name]) return Promise.resolve();
    var ff = new FontFace('CL ' + name, 'url(' + CFG.fonts[name] + ')');
    fontsReady[name] = ff.load().then(function (f) { document.fonts.add(f); }).catch(function () {});
    return fontsReady[name];
  }
  function fontCss(name) { return CFG.fonts[name] ? '"CL ' + name + '"' : (FONT_STACK[name] || 'Arial, sans-serif'); }

  /* ---------- helpers ---------- */
  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') el.className = attrs[k];
      else if (k === 'text') el.textContent = attrs[k];
      else if (k.slice(0, 2) === 'on') el.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) el.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }
  function money(n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function hexOf(list, name) { for (var i = 0; i < list.length; i++) if (list[i][0] === name) return list[i][1]; return '#000'; }
  function reelColor() {
    // default follows the lanyard by family name; colors with no matching reel get black
    if (S.reelColor) return S.reelColor;
    var n = S.color, map = [[/^Black/, 'Black'], [/^White/, 'White'], [/Navy|Dark Blue/, 'Navy Blue'], [/Royal|Blue 072|Aqua|Pale Blue|Sky/, 'Royal Blue'],
      [/Maroon/, 'Maroon'], [/Red/, 'Red'], [/Orange/, 'Orange'], [/Yellow/, 'Yellow'], [/Green|Forest/, 'Green']];
    for (var i = 0; i < map.length; i++) if (map[i][0].test(n)) return map[i][1];
    return 'Black';
  }
  var reelTints = {};
  function tintReel(img, name) {
    // recolor the black housing of the stock reel photo; metal, clear strap and badge clip stay as shot
    if (!img || name === 'Black') return img;
    var key = name; if (reelTints[key]) return reelTints[key];
    var cv = document.createElement('canvas'); cv.width = img.width; cv.height = img.height;
    var cx = cv.getContext('2d'); cx.drawImage(img, 0, 0);
    // Only the housing and its neck (top half of the 2120-7501 photo); the clear strap and its snap below stay as shot.
    // Soft weights instead of a hard cut keep the edges of the shine smooth; light colors get lighter shading.
    var W = cv.width, Hh = Math.round(cv.height * 0.6);
    var d = cx.getImageData(0, 0, W, Hh), px = d.data, t = hexRgb(hexOf(REEL_COLORS, name));
    var Lt = (0.3 * t[0] + 0.59 * t[1] + 0.11 * t[2]) / 255, lo = 0.45 + 0.3 * Lt;
    for (var i = 0; i < px.length; i += 4) {
      if (!px[i + 3]) continue;
      var r = px[i], g = px[i + 1], b = px[i + 2], mx = Math.max(r, g, b), mn = Math.min(r, g, b);
      var w = Math.min(1, Math.max(0, (135 - mx) / 55)) * Math.min(1, Math.max(0, (42 - (mx - mn)) / 16));
      if (w <= 0) continue;
      var k = lo + 0.6 * Math.min(1.2, mx / 95);
      px[i] = r + (Math.min(255, t[0] * k) - r) * w; px[i + 1] = g + (Math.min(255, t[1] * k) - g) * w; px[i + 2] = b + (Math.min(255, t[2] * k) - b) * w;
    }
    cx.putImageData(d, 0, 0);
    return (reelTints[key] = cv);
  }
  function clipBy(code) { for (var i = 0; i < CLIPS.length; i++) if (CLIPS[i][0] === code) return CLIPS[i]; return CLIPS[0]; }
  // "Breakaway" picks black or white from the lanyard color, the way the stock lanyards ship
  // (2138-500X: white clasp on white, yellow, orange; black on the rest)
  function autoBrk() { return lum(hexOf(LANYARD_COLORS, S.color)) > 0.55 ? 'white' : 'black'; }
  function effBreakaway() { return S.breakaway === 'auto' ? autoBrk() : S.breakaway; }
  function brkBy(code) { for (var i = 0; i < BREAKAWAYS.length; i++) if (BREAKAWAYS[i][0] === code) return BREAKAWAYS[i]; return BREAKAWAYS[0]; }
  function shade(hex, amt) {
    var n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    var t = amt < 0 ? 0 : 255, p = Math.abs(amt);
    r = Math.round((t - r) * p + r); g = Math.round((t - g) * p + g); b = Math.round((t - b) * p + b);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }
  function lum(hex) { var n = parseInt(hex.slice(1), 16); return (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255; }

  function currentVariant() {
    var c = clipBy(S.clip)[1], b = brkBy(effBreakaway())[1], s = (S.sides === 'front' || method() === 'WV') ? 'Front only' : 'Front and back';
    for (var i = 0; i < CFG.variants.length; i++) {
      var v = CFG.variants[i];
      if (v.clip === c && v.breakaway === b && v.sides === s) return v;
    }
    return null;
  }
  function qty() { var q = document.querySelector('input[name="quantity"]'); var n = q ? parseInt(q.value, 10) : CFG.minQty; return isFinite(n) ? n : CFG.minQty; }
  function unitAt(q) {
    var v = currentVariant(); if (!v || !TIERS.length) return null;
    var list = v.price / 100, base100 = TIERS[0].base, t = TIERS[0];
    TIERS.forEach(function (x) { if (q >= x.q) t = x; });
    return Math.max(0, list - (base100 - t.base));
  }

  /* ---------- flat strip ---------- */
  function drawTile(ctx, d, x, cy, flip, part) {
    // returns tile width; draws when ctx is given. part: 'logo' | 'text' | (both)
    var logoH = STRIP_H * 0.74, fontPx = STRIP_H * 0.56, gap = STRIP_H * 0.28, w = 0, lw = 0;
    var mctx = ctx || measureCtx();
    if (d.logoImg && part !== 'text') { lw = logoH * d.logoImg.width / d.logoImg.height; w += lw; }
    var txt = part === 'logo' ? '' : (d.text || '').trim();
    mctx.font = '700 ' + fontPx + 'px ' + fontCss(d.font);
    var tw = txt ? mctx.measureText(txt).width : 0;
    if (lw && tw) w += gap;
    w += tw;
    if (!ctx || !w) return w;
    ctx.save();
    ctx.translate(x + w / 2, cy);
    if (flip) ctx.rotate(Math.PI);
    var ox = -w / 2;
    if (lw) { ctx.drawImage(d.logoImg, ox, -logoH / 2, lw, logoH); ox += lw + (tw ? gap : 0); }
    if (tw) { ctx.fillStyle = hexOf(INK_COLORS, d.ink); ctx.textBaseline = 'middle'; ctx.fillText(txt, ox, fontPx * 0.04); }
    ctx.restore();
    return w;
  }
  var _mctx;
  function measureCtx() { if (!_mctx) _mctx = document.createElement('canvas').getContext('2d'); return _mctx; }

  // each clip photo's attachment hole (image px: top, bottom, center x, width), measured from the
  // trimmed cl-*.png alpha: the first enclosed opening from the top (D-ring, reel T-slot, buckle or
  // hook slot, inside of a split ring). The strap threads through it and wraps the bar above it.
  var HOLES = {"sh":[12,54,34.5,40],"ts":[17,68,49.0,75],"sr":[12,128,71.5,104],"sb":[11,48,29.5,36],"sj":[11,123,67.5,100],"sv":[12,108,63.0,93],"lc":[14,54,62.5,92],"jh":[15,52,67.0,101],"bl":[11,48,29.5,36],"rc":[20,29,94.5,50],"dh":[14,52,59.5,90],"dr":[12,23,44.5,62],"dl":[13,23,46.0,65],"dp":[13,23,45.0,65],"db":[12,23,44.5,62],"xh":[11,54,53.5,58],"xs":[10,68,54.5,90],"xb":[16,39,45.5,22],"xr":[15,124,69.5,102],"pwk":[11,31,44.5,58],"pww":[9,31,44.5,64],"pnk":[8,23,35.5,54],"pnw":[8,28,36.0,59],"bc":[8,60,71.0,70],"usb":[8,18,107.5,39],"pj":[25,60,52.0,72],"dt":[20,61,58.5,83],"dlc":[25,65,59.5,85],"dx":[7,20,28.0,36]};
  var HW_K = 3.9 / 299;   // clip px per strap px: the live FPD stage draws the swivel hook (299px photo) 3.9 strap widths long
  var BRK_K = 1.15;  // breakaway clasp ~1.15 strap widths tall, whatever the width
  var SPACING_MAX = 3; // slider far right = one copy per side, centered and mirrored
  function buildStrip(sideKey, opts) {
    opts = opts || {};
    var scale = opts.scale || 1;
    var c = document.createElement('canvas');
    c.width = Math.round(STRIP_W * scale); c.height = Math.round(STRIP_H * scale);
    var ctx = c.getContext('2d');
    ctx.scale(scale, scale);
    var base = hexOf(LANYARD_COLORS, S.color);
    ctx.fillStyle = base; ctx.fillRect(0, 0, STRIP_W, STRIP_H);
    if (!opts.flat) ribs(ctx, base);
    var d = S.d[sideKey];
    if (!opts.blank && S.path === 'design' && (d.text.trim() || d.logoImg)) {
      var single = S.spacing >= SPACING_MAX, spacing = S.spacing * PPI;
      var start = NOPRINT_END_IN * PPI, end = STRIP_W - NOPRINT_END_IN * PPI, mid = STRIP_W / 2;
      var clear = S.breakaway !== 'none' ? BREAKAWAY_CLEAR_IN * PPI : 0;
      // the repeating pattern: logo next to the text as one unit, or logo and text alternating
      // (logo centered between the text repeats), always starting and ending on the text
      var alt = S.logoPos === 'between' && d.logoImg && d.text.trim() && !single;
      var units = alt ? [{ part: 'text', w: drawTile(null, d, 0, 0, false, 'text') }, { part: 'logo', w: drawTile(null, d, 0, 0, false, 'logo') }]
                      : [{ part: null, w: drawTile(null, d, 0, 0, false) }];
      if (units[0].w > 0) {
        // fill each half separately so nothing prints under the breakaway clasp; the halves
        // are the same length, so equal fills mirror around the neck
        [[start, mid - clear, S.layout === 'mirrored'], [mid + clear, end, false]].forEach(function (seg) {
          var a = seg[0], b = seg[1], len = b - a, seq = [], used = 0;
          for (var i = 0; ; i++) {
            var u = units[i % units.length], add = (seq.length ? spacing : 0) + u.w;
            if (single ? seq.length >= 1 : used + add > len) break;
            seq.push(u); used += add;
          }
          if (alt && seq.length > 1 && seq[seq.length - 1].part === 'logo') { used -= spacing + seq.pop().w; }
          if (!seq.length) { seq.push(units[0]); used = units[0].w; }
          var x = a + (len - used) / 2;
          seq.forEach(function (u) { drawTile(ctx, d, x, STRIP_H / 2, seg[2], u.part); x += u.w + spacing; });
        });
      }
    }
    if (!opts.flat) { ctx.globalAlpha = 0.6; ribs(ctx, base); ctx.globalAlpha = 1; }
    return c;
  }
  function ribs(ctx, base) {
    // Polyester webbing (stock 2138-500X close-ups): fine ribs running ACROSS the strap, about
    // 1 mm apart and a little wavy, plus slightly darker edges. Kept faint; it should read as
    // fabric, not stripes.
    var a = lum(base) > 0.5 ? 0.045 : 0.09, pitch = 2.6; // 64 px/in -> ~1 mm
    ctx.save(); ctx.lineWidth = 1.1;
    for (var x = 0; x < STRIP_W; x += pitch) {
      ctx.strokeStyle = 'rgba(0,0,0,' + (a * (0.7 + 0.3 * Math.sin(x * 0.37))).toFixed(3) + ')';
      ctx.beginPath(); ctx.moveTo(x, 0);
      ctx.quadraticCurveTo(x + 0.9 * Math.sin(x * 0.11), STRIP_H / 2, x + 0.4 * Math.sin(x * 0.07), STRIP_H); ctx.stroke();
    }
    ctx.restore();
    var g = ctx.createLinearGradient(0, 0, 0, STRIP_H);
    g.addColorStop(0, 'rgba(0,0,0,0.12)'); g.addColorStop(0.12, 'rgba(0,0,0,0)'); g.addColorStop(0.5, 'rgba(255,255,255,0.04)');
    g.addColorStop(0.88, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,0.14)');
    ctx.fillStyle = g; ctx.fillRect(0, 0, STRIP_W, STRIP_H);
  }

  /* ---------- hanging view ---------- */
  var VIEW_W = 600, VIEW_H = 800;
  function loopPath() {
    // teardrop: two straight legs from the clip point J, tangent to a circle (the neck)
    var J = { x: 300, y: 590 }, C = { x: 300, y: 178 }, R = 112;
    var d = J.y - C.y, t = Math.sqrt(d * d - R * R), a = Math.acos(R / d);
    // tangent points: angle measured from C, pointing down = PI/2
    var aL = Math.PI / 2 + a, aR = Math.PI / 2 - a;
    var TL = { x: C.x + R * Math.cos(aL), y: C.y + R * Math.sin(aL) };
    var TR = { x: C.x + R * Math.cos(aR), y: C.y + R * Math.sin(aR) };
    var arc = (2 * Math.PI - 2 * a) * R;
    var total = 2 * t + arc;
    function at(s) {
      if (s <= t) { var f = s / t; return { x: J.x + (TL.x - J.x) * f, y: J.y + (TL.y - J.y) * f, ang: Math.atan2(TL.y - J.y, TL.x - J.x) }; }
      s -= t;
      if (s <= arc) { var th = aL + s / R; return { x: C.x + R * Math.cos(th), y: C.y + R * Math.sin(th), ang: th + Math.PI / 2 }; }
      s -= arc; var g = s / t;
      return { x: TR.x + (J.x - TR.x) * g, y: TR.y + (J.y - TR.y) * g, ang: Math.atan2(J.y - TR.y, J.x - TR.x) };
    }
    return { J: J, C: C, R: R, total: total, at: at, top: { x: C.x, y: C.y - R } };
  }

  /* ---------- worn view: draped over a neutral bust ----------
     The strap lies flat facing the viewer down the chest, turns on edge as it climbs over the
     shoulders (narrower, darker), and the back of the loop runs behind the neck. Path = a
     Catmull-Rom curve through these points, sampled by arc length; w = how much of the strap's
     face we see (1 = flat to the camera), back = the part behind the neck. */
  // A flat strap can't bend sideways, only twist or fold. Worn view: two straight legs from the
  // clip; at each shoulder the strap twists through edge-on (w -> 0) and flips, so across the back
  // of the neck we see the inside of the band, gently curved around the neck.
  var _worn = null;
  function wornPath() {
    if (_worn) return _worn;
    var J = { x: 300, y: 640 }, TL = { x: 214, y: 124 }, TR = { x: 386, y: 124 }, CTRL = { x: 300, y: 84 };
    var pts = [];
    function line(a, b, n) { for (var i = 0; i < n; i++) pts.push([a.x + (b.x - a.x) * i / n, a.y + (b.y - a.y) * i / n]); }
    function quad(a, c, b, n) { for (var i = 0; i < n; i++) { var t = i / n, u = 1 - t; pts.push([u * u * a.x + 2 * u * t * c.x + t * t * b.x, u * u * a.y + 2 * u * t * c.y + t * t * b.y]); } }
    line(J, TL, 300); quad(TL, CTRL, TR, 200); line(TR, J, 300); pts.push([J.x, J.y]);
    var len = [0];
    for (var j = 1; j < pts.length; j++) len.push(len[j - 1] + Math.hypot(pts[j][0] - pts[j - 1][0], pts[j][1] - pts[j - 1][1]));
    var total = len[len.length - 1], legLen = len[300], bandEnd = len[500], TW = 30; // twist half-length, px
    function at(sv) {
      var lo = 0, hi = len.length - 1;
      while (hi - lo > 1) { var m = (lo + hi) >> 1; if (len[m] < sv) lo = m; else hi = m; }
      var a = pts[lo], b = pts[Math.min(hi, pts.length - 1)], f = (sv - len[lo]) / Math.max(1e-6, len[hi] - len[lo]);
      var d = Math.min(Math.abs(sv - legLen), Math.abs(sv - bandEnd));
      var w = d < TW ? Math.max(0.04, Math.abs(Math.sin(d / TW * Math.PI / 2))) : 1;
      var back = sv > legLen && sv < bandEnd;
      return { x: a[0] + (b[0] - a[0]) * f, y: a[1] + (b[1] - a[1]) * f, ang: Math.atan2(b[1] - a[1], b[0] - a[0]), w: w, back: back };
    }
    var mid = at((legLen + bandEnd) / 2);
    _worn = { J: J, total: total, at: at, top: { x: mid.x, y: mid.y, ang: mid.ang }, worn: true };
    return _worn;
  }
  function drawBust(ctx) {
    // neutral mannequin: neck and shoulders, soft light gray
    ctx.save();
    var g = ctx.createLinearGradient(0, 80, 0, VIEW_H);
    g.addColorStop(0, '#e7e5e1'); g.addColorStop(1, '#d9d6d0');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.moveTo(262, -20); ctx.lineTo(262, 120);
    ctx.bezierCurveTo(262, 168, 200, 186, 120, 204);
    ctx.bezierCurveTo(60, 218, 30, 250, 22, 320);
    ctx.lineTo(10, VIEW_H + 20); ctx.lineTo(VIEW_W - 10, VIEW_H + 20); ctx.lineTo(VIEW_W - 22, 320);
    ctx.bezierCurveTo(570, 250, 540, 218, 480, 204);
    ctx.bezierCurveTo(400, 186, 338, 168, 338, 120);
    ctx.lineTo(338, -20); ctx.closePath(); ctx.fill();
    // collarbone shading
    var ng = ctx.createRadialGradient(300, 150, 10, 300, 170, 120);
    ng.addColorStop(0, 'rgba(0,0,0,0.07)'); ng.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = ng; ctx.fillRect(160, 100, 280, 160);
    ctx.restore();
  }
  function drawWorn(ctx, strip, P) {
    var s = P.total / STRIP_W, wv = STRIP_H * s, base = hexOf(LANYARD_COLORS, S.color), step = 2;
    // soft shadow under the whole strap
    ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.20)'; ctx.shadowBlur = 12; ctx.shadowOffsetY = 6; ctx.strokeStyle = base; ctx.lineCap = 'butt';
    for (var k = 0; k < 400; k++) {
      var q0 = P.at(P.total * k / 400), q1 = P.at(P.total * (k + 1) / 400);
      ctx.lineWidth = wv * Math.min(q0.w, q1.w); ctx.beginPath(); ctx.moveTo(q0.x, q0.y); ctx.lineTo(q1.x, q1.y); ctx.stroke();
    }
    ctx.restore();
    for (var x = 0; x < STRIP_W; x += step) {
      var p = P.at((x + step / 2) * s), h = wv * p.w;
      ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.ang);
      if (p.back) {
        // the inside of the band behind the neck: same webbing, unprinted, in shadow
        ctx.fillStyle = shade(base, lum(base) > 0.5 ? -0.16 : -0.28);
        ctx.fillRect(-step * s / 2 - 0.4, -h / 2, step * s + 0.8, h);
      } else {
        ctx.drawImage(strip, x * strip.width / STRIP_W, 0, step * strip.width / STRIP_W, strip.height, -step * s / 2 - 0.35, -h / 2, step * s + 0.7, h);
      }
      // twisting toward edge-on, the face turns away from the light
      if (p.w < 1) { ctx.fillStyle = 'rgba(0,0,0,' + (0.38 * (1 - p.w)).toFixed(3) + ')'; ctx.fillRect(-step * s / 2 - 0.35, -h / 2, step * s + 0.7, h); }
      ctx.restore();
    }
    return { P: P, s: s, wv: wv, ctx: ctx };
  }

  /* ---------- folded view (default) ----------
     How a lanyard actually lies: two straight legs from the clip, a 45-degree-ish fold at each top
     corner, and the top band showing the back face (with the breakaway on it). A flat strap never
     bends sideways, so nothing here curves. Geometry is true to a 36" lanyard: 5/8" wide, the legs
     and band add up to the strip length at one scale. */
  var FOLD = { J: { x: 300, y: 650 }, CL: { x: 172, y: 130 }, CR: { x: 428, y: 130 } };
  function unit(a, b) { var dx = b.x - a.x, dy = b.y - a.y, l = Math.hypot(dx, dy); return { x: dx / l, y: dy / l, l: l }; }
  function drawFolded(ctx, strip, backStrip) {
    var J = FOLD.J, CL = FOLD.CL, CR = FOLD.CR;
    var u1 = unit(J, CL), ub = unit(CL, CR), u2 = unit(CR, J);
    var total = u1.l + ub.l + u2.l, s = total / STRIP_W, wv = STRIP_H * s, base = hexOf(LANYARD_COLORS, S.color);
    var ext = wv * 2;
    // A fold, not a miter: the crease runs through the corner at right angles to the bisector of
    // the turn and becomes the outer edge, so the corner gets a full-width 45-degree chamfer
    // (like the live FPD designer and a real folded strap). Both pieces stay on the inner side.
    function crease(uIn, uOut) { var mx = -uIn.x + uOut.x, my = -uIn.y + uOut.y, l = Math.hypot(mx, my) || 1; return { x: -my / l, y: mx / l }; }
    var mL = crease(u1, ub), mR = crease(ub, u2);
    // keep the side of a crease line that contains point q
    function halfPlane(ctx2, c, m, q) {
      var nx = -m.y, ny = m.x; if ((q.x - c.x) * nx + (q.y - c.y) * ny < 0) { nx = -nx; ny = -ny; }
      var R = 2000; ctx2.beginPath();
      ctx2.moveTo(c.x + m.x * R, c.y + m.y * R); ctx2.lineTo(c.x - m.x * R, c.y - m.y * R);
      ctx2.lineTo(c.x - m.x * R + nx * R, c.y - m.y * R + ny * R); ctx2.lineTo(c.x + m.x * R + nx * R, c.y + m.y * R + ny * R); ctx2.closePath();
    }
    // draw strip[x0..x0+len] (strip px) along a from->dir, clipped to the given creases
    function segment(src, x0, from, u, len, clips, tint) {
      ctx.save();
      clips.forEach(function (c) { halfPlane(ctx, c[0], c[1], c[2]); ctx.clip(); });
      ctx.translate(from.x, from.y); ctx.rotate(Math.atan2(u.y, u.x));
      var sx0 = Math.max(0, x0 - ext / s), sx1 = Math.min(STRIP_W, x0 + (len + ext) / s);
      ctx.drawImage(src, sx0 * src.width / STRIP_W, 0, (sx1 - sx0) * src.width / STRIP_W, src.height, (sx0 - x0) * s, -wv / 2, (sx1 - sx0) * s, wv);
      if (tint) { ctx.fillStyle = tint; ctx.fillRect((sx0 - x0) * s, -wv / 2, (sx1 - sx0) * s, wv); }
      ctx.restore();
    }
    var bandMid = { x: (CL.x + CR.x) / 2, y: (CL.y + CR.y) / 2 };
    // legs first; the band is the folded-over part, so it lies on top at the corners and shows the
    // back face of the strap
    ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.22)'; ctx.shadowBlur = 10; ctx.shadowOffsetY = 5;
    segment(strip, 0, J, u1, u1.l, [[CL, mL, J]], null);
    segment(strip, (u1.l + ub.l) / s, CR, u2, u2.l, [[CR, mR, J]], null);
    ctx.restore();
    ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.25)'; ctx.shadowBlur = 3; ctx.shadowOffsetY = 1.5;
    segment(backStrip, u1.l / s, CL, ub, ub.l, [[CL, mL, bandMid], [CR, mR, bandMid]], null); // no darkening: the back reads as the same color as the front (Patrick)
    ctx.restore();
    // the fold edge: a light highlight with a soft shadow just inside it
    ctx.save();
    [[CL, mL, u1], [CR, mR, u2]].forEach(function (c) {
      var r = wv * 0.75;
      ctx.strokeStyle = 'rgba(255,255,255,0.18)'; ctx.lineWidth = 1;
      ctx.beginPath(); ctx.moveTo(c[0].x - c[1].x * r, c[0].y - c[1].y * r); ctx.lineTo(c[0].x + c[1].x * r, c[0].y + c[1].y * r); ctx.stroke();
    });
    ctx.restore();
    return { P: { J: J, total: total, top: { x: bandMid.x, y: bandMid.y, ang: 0 }, legs: [u1, u2] }, s: s, wv: wv, ctx: ctx };
  }

  // Woven is one fabric: the back is the front's design seen through the cloth (stock photos Woven.png,
  // Woven3.png): mirrored, with lanyard and thread colors swapped (black + green text -> green + black
  // text), and a thin line of the front's base color just inside each edge.
  function wovenBack(sc) {
    var src = buildStrip('front', { scale: sc });
    var cv = document.createElement('canvas'); cv.width = src.width; cv.height = src.height;
    var cx = cv.getContext('2d');
    cx.translate(0, cv.height); cx.scale(1, -1); cx.drawImage(src, 0, 0); cx.setTransform(1, 0, 0, 1, 0, 0);
    var f = S.d.front, base = hexRgb(hexOf(LANYARD_COLORS, S.color));
    var inkName = f.text.trim() || !f.logoInkList ? f.ink : f.logoInkList[0];
    var ink = hexRgb(hexOf(INK_COLORS, inkName));
    var dx = ink[0] - base[0], dy = ink[1] - base[1], dz = ink[2] - base[2], dd = dx * dx + dy * dy + dz * dz || 1;
    var img = cx.getImageData(0, 0, cv.width, cv.height), px = img.data;
    for (var i = 0; i < px.length; i += 4) {
      // how far this pixel is from the base toward the thread color (0 = base, 1 = thread); keep the
      // rib texture as an offset and swap the two colors
      var r = px[i] - base[0], g = px[i + 1] - base[1], b = px[i + 2] - base[2];
      var t = Math.max(0, Math.min(1, (r * dx + g * dy + b * dz) / dd));
      var er = r - dx * t, eg = g - dy * t, eb = b - dz * t;
      px[i] = ink[0] - dx * t + er; px[i + 1] = ink[1] - dy * t + eg; px[i + 2] = ink[2] - dz * t + eb;
    }
    cx.putImageData(img, 0, 0);
    var hgt = cv.height, line = Math.max(1, Math.round(hgt * 0.045)), inset = Math.round(hgt * 0.035);
    cx.fillStyle = hexOf(LANYARD_COLORS, S.color);
    cx.fillRect(0, inset, cv.width, line); cx.fillRect(0, hgt - inset - line, cv.width, line);
    return cv;
  }

  // what the folded-over top band shows: the back face
  function backStrip(sc, face) {
    // the folded band shows the reverse of whatever side is on screen
    if (method() === 'WV') return wovenBack(sc);
    if (S.sides === 'front') return buildStrip('front', { scale: sc, blank: true });
    if (S.sides === 'same') return buildStrip('front', { scale: sc });
    return buildStrip(face === 'back' ? 'front' : 'back', { scale: sc });
  }
  function drawHanging(canvas, strip, view) {
    view = view || { z: 1, x: 0, y: 0 };
    var dpr = Math.min(2, window.devicePixelRatio || 1) * 1.25;
    canvas.width = VIEW_W * dpr; canvas.height = VIEW_H * dpr;
    var ctx = canvas.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    // zoom about the view center, then pan
    var z = view.z;
    ctx.setTransform(dpr * z, 0, 0, dpr * z, dpr * (VIEW_W / 2 * (1 - z) + view.x), dpr * (VIEW_H / 2 * (1 - z) + view.y));
    if (S.viewMode === 'worn') return drawWorn(ctx, strip, wornPath());
    if (S.viewMode !== 'loop') return drawFolded(ctx, strip, view.back || strip);
    var P = loopPath(), s = P.total / STRIP_W, wv = STRIP_H * s;
    var base = hexOf(LANYARD_COLORS, S.color);

    // soft shadow under the loop
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,0.22)'; ctx.shadowBlur = 14; ctx.shadowOffsetY = 7;
    ctx.strokeStyle = base; ctx.lineWidth = wv; ctx.beginPath();
    for (var k = 0; k <= 400; k++) { var p0 = P.at(P.total * k / 400); k ? ctx.lineTo(p0.x, p0.y) : ctx.moveTo(p0.x, p0.y); }
    ctx.stroke(); ctx.restore();

    // bend the strip along the loop
    var step = z > 2 ? 1 : 2;
    for (var x = 0; x < STRIP_W; x += step) {
      var p = P.at((x + step / 2) * s);
      ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.ang);
      ctx.drawImage(strip, x * strip.width / STRIP_W, 0, step * strip.width / STRIP_W, strip.height, -step * s / 2 - 0.35, -wv / 2, step * s + 0.7, wv);
      ctx.restore();
    }
    return { P: P, s: s, wv: wv, ctx: ctx };
  }

  function drawHardware(view) {
    // Built like a real lanyard end (2135-350X / 2138-500X photos): the two legs meet, the strap
    // runs down as one, gets closed off (sewn bar tacks or a metal crimp sleeve), and below
    // that a short loop wraps around the top bar of the clip's ring. The strap is in front of the
    // bar, so the bar disappears into the fold. Clips and metal parts are true size whatever the width.
    var ctx = view.ctx, P = view.P, s = view.s, wv = view.wv, J = P.J, pxIn = PPI * s;
    var wRef = 0.625 * pxIn; // a 5/8" strap at this scale: clips are sized against it
    var clip = clipBy(S.clip), brk = brkBy(effBreakaway()), fin = S.finish;
    return Promise.all([loadImg(CFG.img[clip[0]]), loadImg(brk[2] ? CFG.img[brk[2]] : null)]).then(function (imgs) {
      var hw = clip[0] === 'rc' ? tintReel(imgs[0], reelColor()) : imgs[0], bi = imgs[1];
      var base = hexOf(LANYARD_COLORS, S.color);
      // same cross-ribbed webbing as the legs (ribs run across the strap: horizontal here)
      var tile = document.createElement('canvas'); tile.width = 8; tile.height = Math.max(2, Math.round(0.04 * pxIn));
      var tc = tile.getContext('2d'); tc.fillStyle = base; tc.fillRect(0, 0, tile.width, tile.height);
      tc.fillStyle = lum(base) > 0.5 ? 'rgba(0,0,0,0.06)' : 'rgba(0,0,0,0.14)'; tc.fillRect(0, 0, tile.width, Math.max(1, tile.height / 2.5));
      var ribPat = ctx.createPattern(tile, 'repeat');
      // Built from stock close-ups (2136-350X / 2135-350X crimps, sewn ends): below the V the two ends
      // run as ONE full-width strap; at a crimp it pinches short and hard into the sleeve, puffs
      // back out under it, runs about one strap width and folds around the clip ring's top bar (bar hidden
      // in the fold). Sewn ends stay full width down to the fold. Straight edges only: webbing doesn't bow.
      // same strap either way, so the fold sits at the same spot for sewn and crimp (Patrick, 2026-10-25)
      var IN = pxIn, top = J.y - 0.15 * IN, knots, barY = J.y + 0.85 * IN, shape = null;
      if (fin === 'Sewn') {
        knots = [[top, wv], [barY, wv]];
      } else {
        var mW = Math.max(wv * 0.56, 0.24 * IN);  // crimp sleeve width
        var mH = 0.42 * IN;                        // crimp sleeve height
        var inner = Math.min(wv, mW * 0.86);                                                // strap inside it
        var pinchTop = J.y + 0.1 * IN, mTop = pinchTop + 0.1 * IN, mBot = mTop + mH;
        var puff = wv * 0.82;
        knots = [[top, wv], [pinchTop, wv], [mTop + 0.04 * IN, inner], [mBot - 0.04 * IN, inner], [mBot + 0.06 * IN, puff], [barY, puff]];
        shape = { x: J.x - mW / 2, y: mTop, w: mW, h: mH, pinchTop: pinchTop, inner: inner, puff: puff, mBot: mBot };
      }
      // the clip hangs centered on its attachment hole; the strap's fold sits inside the top of the hole
      // (wrapping the bar above it), and the strap narrows just above the fold if the hole is narrower
      if (hw) {
        var k = wRef * HW_K, ww = hw.width * k, hh = hw.height * k, hole = HOLES[clip[0]];
        var holeTop = hole ? hole[0] * k : 0.1 * IN, holeH = hole ? (hole[1] - hole[0]) * k : 0.2 * IN;
        var holeW = hole ? hole[3] * k : wv, cx = hole ? hole[2] * k : ww / 2;
        var depth = Math.min(holeH * 0.55, holeW * 0.4, 0.14 * IN);
        var foldW = Math.min(knots[knots.length - 1][1], holeW * 0.92);
        if (foldW < knots[knots.length - 1][1] * 0.97) {
          // gather into the ring: keep the strap's width until just above the fold, then taper
          var lastW = knots[knots.length - 1][1];
          knots[knots.length - 1] = [barY - 0.16 * IN, lastW];
          knots.push([barY - 0.03 * IN, foldW], [barY, foldW]);
        }
        ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.25)'; ctx.shadowBlur = 6; ctx.shadowOffsetY = 3;
        ctx.drawImage(hw, J.x - cx, barY - holeTop - depth, ww, hh); ctx.restore();
      }
      function fillStrap() {
        ctx.fillStyle = ribPat; ctx.fill();
        var g = ctx.createLinearGradient(J.x - wv / 2, 0, J.x + wv / 2, 0);
        g.addColorStop(0, 'rgba(0,0,0,0.18)'); g.addColorStop(0.5, 'rgba(255,255,255,0.05)'); g.addColorStop(1, 'rgba(0,0,0,0.22)');
        ctx.fillStyle = g; ctx.fill();
      }
      // straight-sided strap through the knots ([y, width] top to bottom), square fold with soft corners
      function strap(kn) {
        var last = kn[kn.length - 1], r = Math.min(last[1] * 0.16, 0.05 * IN);
        ctx.beginPath(); ctx.moveTo(J.x - kn[0][1] / 2, kn[0][0]);
        for (var i = 1; i < kn.length - 1; i++) ctx.lineTo(J.x - kn[i][1] / 2, kn[i][0]);
        ctx.lineTo(J.x - last[1] / 2, last[0] - r); ctx.quadraticCurveTo(J.x - last[1] / 2, last[0], J.x - last[1] / 2 + r, last[0]);
        ctx.lineTo(J.x + last[1] / 2 - r, last[0]); ctx.quadraticCurveTo(J.x + last[1] / 2, last[0], J.x + last[1] / 2, last[0] - r);
        for (var j = kn.length - 2; j >= 0; j--) ctx.lineTo(J.x + kn[j][1] / 2, kn[j][0]);
        ctx.closePath(); fillStrap();
      }
      // drawn on its own layer with the top 0.12" faded, so the merged strap melts into the two legs
      var main = ctx, off = document.createElement('canvas');
      off.width = main.canvas.width; off.height = main.canvas.height;
      var oc = off.getContext('2d'); oc.setTransform(main.getTransform());
      ctx = oc; strap(knots);
      // bunched fabric where it pinches in and puffs out
      if (shape) {
        oc.strokeStyle = 'rgba(0,0,0,0.2)'; oc.lineWidth = Math.max(0.5, 0.01 * IN);
        [-0.3, 0, 0.3].forEach(function (f) {
          oc.beginPath(); oc.moveTo(J.x + f * wv, shape.pinchTop - 0.04 * IN); oc.lineTo(J.x + f * shape.inner, shape.y); oc.stroke();
          oc.beginPath(); oc.moveTo(J.x + f * shape.inner, shape.mBot); oc.lineTo(J.x + f * shape.puff, shape.mBot + 0.06 * IN); oc.stroke();
        });
      }
      ctx = main;
      oc.globalCompositeOperation = 'destination-in';
      var fade = oc.createLinearGradient(0, top, 0, top + 0.12 * IN);
      fade.addColorStop(0, 'rgba(0,0,0,0)'); fade.addColorStop(1, 'rgba(0,0,0,1)');
      oc.fillStyle = fade; oc.fillRect(J.x - 2 * IN, top - 1, 4 * IN, 8 * IN);
      main.save(); main.setTransform(1, 0, 0, 1, 0, 0); main.drawImage(off, 0, 0); main.restore();

      ctx.save();
      if (fin === 'Sewn') {
        ctx.strokeStyle = lum(base) > 0.6 ? 'rgba(0,0,0,0.45)' : 'rgba(255,255,255,0.6)';
        ctx.lineWidth = Math.max(0.6, 0.02 * IN); ctx.setLineDash([0.05 * IN, 0.03 * IN]);
        [barY - 0.34 * IN, barY - 0.2 * IN].forEach(function (y) { ctx.beginPath(); ctx.moveTo(J.x - wv * 0.42, y); ctx.lineTo(J.x + wv * 0.42, y); ctx.stroke(); });
        ctx.setLineDash([]);
      } else {
        var mx = shape.x, my = shape.y, mw = shape.w, mh = shape.h;
        ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.3)'; ctx.shadowBlur = 3; ctx.shadowOffsetY = 1;
        var mg = ctx.createLinearGradient(mx, 0, mx + mw, 0);
        mg.addColorStop(0, '#7e838a'); mg.addColorStop(0.22, '#e9ecef'); mg.addColorStop(0.46, '#b9bec3'); mg.addColorStop(0.76, '#f6f8f9'); mg.addColorStop(1, '#747980');
        ctx.fillStyle = mg;
        // crimp sleeve: straight sides, ends rolled in slightly
        roundRect(ctx, mx, my, mw, mh, Math.min(2.5, mw * 0.1)); ctx.fill(); ctx.restore();
        ctx.save(); ctx.strokeStyle = 'rgba(0,0,0,0.22)'; ctx.lineWidth = 0.6; roundRect(ctx, mx, my, mw, mh, Math.min(2.5, mw * 0.1)); ctx.stroke();
        ctx.strokeStyle = 'rgba(0,0,0,0.16)';
        [0.1, 0.9].forEach(function (f) { var y = my + mh * f; ctx.beginPath(); ctx.moveTo(mx + 1, y); ctx.lineTo(mx + mw - 1, y); ctx.stroke(); });
        ctx.restore();
      }
      ctx.restore();
      if (bi && P.top) {
        // sized to the strap: each width ships with its own matching breakaway (3/8" strap = 3/8" clasp)
        var bh = wv * BRK_K, bw = bh * bi.width / bi.height;
        ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.25)'; ctx.shadowBlur = 5; ctx.shadowOffsetY = 2;
        ctx.translate(P.top.x, P.top.y); if (P.top.ang) ctx.rotate(P.top.ang); ctx.drawImage(bi, -bw / 2, -bh / 2, bw, bh); ctx.restore();
      }
    });
  }
  // draw img rotated 90 deg, centered at (cx, cy): `len` along the strap (vertical), `wid` across it
  function drawUpright(ctx, img, cx, cy, len, wid) {
    ctx.save(); ctx.translate(cx, cy); ctx.rotate(Math.PI / 2);
    ctx.shadowColor = 'rgba(0,0,0,0.25)'; ctx.shadowBlur = 4; ctx.shadowOffsetY = 2;
    ctx.drawImage(img, -len / 2, -wid / 2, len, wid); ctx.restore();
  }
  function roundRect(ctx, x, y, w, hgt, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + hgt, r); ctx.arcTo(x + w, y + hgt, x, y + hgt, r); ctx.arcTo(x, y + hgt, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }

  /* ---------- close-up (flat) ---------- */
  function drawCloseup(canvas, strip) {
    // the second half reads upright in both layouts (mirrored flips the first half)
    // drag sideways to slide along the whole 36" strip (S.closeFrom, inches); starts on the second half
    var cssW = canvas.clientWidth || 560, inches = 9, from = S.closeFrom != null ? S.closeFrom : LEN_IN / 2 + (S.breakaway !== 'none' ? BREAKAWAY_CLEAR_IN : 0) - 0.4;
    from = Math.max(0, Math.min(LEN_IN - inches, from)); canvas._cl = { strip: strip, from: from, inches: inches, cssW: cssW };
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var hgt = Math.round(cssW * (W_IN / inches));
    canvas.style.height = hgt + 'px';
    canvas.width = cssW * dpr; canvas.height = hgt * dpr;
    var ctx = canvas.getContext('2d');
    var sx = from * PPI * strip.width / STRIP_W, sw = inches * PPI * strip.width / STRIP_W;
    ctx.drawImage(strip, sx, 0, sw, strip.height, 0, 0, canvas.width, canvas.height);
  }

  function bindCloseDrag(cv) {
    if (cv._clDrag) return; cv._clDrag = true;
    var start = null;
    cv.addEventListener('pointerdown', function (e) { if (!cv._cl) return; start = { x: e.clientX, from: cv._cl.from }; cv.setPointerCapture(e.pointerId); cv.classList.add('is-drag'); });
    cv.addEventListener('pointermove', function (e) {
      if (!start || !cv._cl) return;
      S.closeFrom = start.from - (e.clientX - start.x) / cv._cl.cssW * cv._cl.inches;
      drawCloseup(cv, cv._cl.strip);
    });
    function end() { start = null; cv.classList.remove('is-drag'); }
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
  }

  /* ---------- UI ---------- */
  var ui = {};
  function mount() {
    var info = document.querySelector('.product__info-container');
    var mediaWrap = document.querySelector('.product__media-wrapper');
    var form = document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"][data-type="add-to-cart-form"]');
    if (!info || !form) return;
    document.documentElement.classList.add('cl-on');

    // stage
    ui.hang = h('canvas', { class: 'cl-hang', role: 'img', 'aria-label': 'Preview of your lanyard' });
    ui.close = h('canvas', { class: 'cl-close', role: 'img', 'aria-label': 'Flat view of the print, drag sideways to see the whole lanyard' });
    ui.sideTabs = h('div', { class: 'cl-sidetabs', role: 'group', 'aria-label': 'Side shown' }, [
      h('button', { type: 'button', class: 'cl-pill is-on', 'data-side': 'front', onclick: function () { setSide('front'); }, text: 'Front' }),
      h('button', { type: 'button', class: 'cl-pill', 'data-side': 'back', onclick: function () { setSide('back'); }, text: 'Back' })
    ]);
    ui.zoomIn = h('button', { type: 'button', class: 'cl-zoom__b', 'aria-label': 'Zoom in', text: '+', onclick: function () { zoomBy(1.4); } });
    ui.zoomOut = h('button', { type: 'button', class: 'cl-zoom__b', 'aria-label': 'Zoom out', text: '−', onclick: function () { zoomBy(1 / 1.4); } });
    ui.zoomReset = h('button', { type: 'button', class: 'cl-zoom__b cl-zoom__b--reset', text: 'Reset', onclick: function () { S.view = { z: 1, x: 0, y: 0 }; render(); } });
    var zoomBar = h('div', { class: 'cl-zoom' }, [ui.zoomOut, ui.zoomIn, ui.zoomReset]);
    ui.photo = h('img', { class: 'cl-photo', alt: '', hidden: true });
    ui.stage = h('div', { class: 'cl-stage', 'data-spid-mini-stage': '' }, [h('div', { class: 'cl-stage__hang' }, [ui.hang, ui.photo, zoomBar]), ui.sideTabs, ui.close]);
    bindZoom(ui.hang);
    if (mediaWrap) { mediaWrap.classList.add('cl-media'); mediaWrap.prepend(ui.stage); }
    else info.prepend(ui.stage);
    mountRail();

    // price + tiers under the title
    ui.price = h('div', { class: 'cl-price' });
    ui.tiers = h('div', { class: 'cl-tiers', role: 'group', 'aria-label': 'Price per lanyard by quantity' });
    ui.sku = h('div', { class: 'cl-sku' });
    var title = info.querySelector('.product__title');
    var priceBox = h('div', { class: 'cl-pricebox' }, [ui.price, ui.tiers, ui.sku]);
    if (title) title.after(priceBox); else info.prepend(priceBox);

    // design card above quantity
    ui.card = buildCard();
    var qtyBlock = info.querySelector('.product-form__quantity');
    var anchor = qtyBlock ? (qtyBlock.closest('.product-form__input, div[id^="Quantity-Form"], .quantity-selector-wrapper') || qtyBlock) : form;
    anchor.parentNode.insertBefore(ui.card, anchor);

    // total + lead time + validation message after quantity
    ui.total = h('div', { class: 'cl-total' });
    ui.next = h('div', { class: 'cl-next' });
    ui.lead = h('p', { class: 'cl-lead' }, [document.createTextNode((CFG.leadTime || '') + ' '), h('a', { href: CFG.contactUrl, text: 'Need it sooner? Talk to sales' })]);
    ui.err = h('p', { class: 'cl-err', role: 'alert' });
    // quantity and total share one row at the same height (Patrick, 2026-10-13); the next-tier nudge sits above it
    var qtyRow = h('div', { class: 'cl-qtyrow' });
    anchor.parentNode.insertBefore(ui.next, anchor);
    anchor.parentNode.insertBefore(qtyRow, anchor);
    qtyRow.appendChild(anchor); qtyRow.appendChild(ui.total);
    var after = h('div', { class: 'cl-after' }, [ui.lead, ui.err]);
    qtyRow.after(after);

    var q = document.querySelector('input[name="quantity"]');
    if (q) { ['input', 'change'].forEach(function (ev) { q.addEventListener(ev, updatePrice); }); }
    document.addEventListener('click', function (e) { if (e.target.closest('.quantity__button')) setTimeout(updatePrice, 0); });

    ui.form = form;
    document.addEventListener('submit', onSubmit, true);
    window.addEventListener('resize', debounce(function () { render(); }, 150));

    if (S.key) { engineCache[S.key] = CFG.variants; TIERS = tiersFor(S.key) && !CFG.tiersOverride ? tiersFor(S.key) : TIERS; W_IN = widthIn(); STRIP_H = Math.round(W_IN * PPI); }
    refreshAll();
    if (FULL) {
      var qp = new URLSearchParams(location.search), pm = (qp.get('print') || '').toUpperCase(), pw = qp.get('width') || widthCode();
      if (/^(SS|DS|WV)$/.test(pm)) setEngine(pm + pw);
    }
  }

  var stepN = 0;
  function section(num, title, body, extraHead) {
    num = ++stepN;
    var head = h('h3', { class: 'cl-step__h' }, [h('span', { class: 'cl-num', 'aria-hidden': 'true', text: String(num) }), h('span', { text: title })]);
    if (extraHead) head.appendChild(extraHead);
    return h('section', { class: 'cl-step' }, [head].concat(body));
  }

  function buildCard() {
    var card = h('div', { class: 'cl-card' });
    card.setAttribute('role', 'group'); card.setAttribute('aria-label', 'Customize your lanyard'); // no visible heading: the product title already says it (Patrick)

    // 0. lanyard: width + print method (full designer)
    if (FULL) {
      ui.widths = h('div', { class: 'cl-pills', role: 'radiogroup', 'aria-label': 'Width' }, WIDTHS.map(function (w) {
        return h('button', { type: 'button', role: 'radio', class: 'cl-pill', 'data-v': w[0], onclick: function () { setEngine(method() + w[0]); }, text: w[2] });
      }));
      ui.methods = h('div', { class: 'cl-paths', role: 'radiogroup', 'aria-label': 'Print method' }, ['SS', 'DS', 'WV'].map(function (m) {
        return h('button', { type: 'button', role: 'radio', class: 'cl-path', 'data-v': m, onclick: function () { setEngine(m + widthCode()); } },
          [h('span', { class: 'cl-path__t', text: m === 'DS' ? 'Dye sub' : METHODS[m].name, title: METHODS[m].name }), h('span', { class: 'cl-path__s', text: METHODS[m].sub })]);
      }));
      ui.methodSub = h('span', { class: 'cl-step__v' });
      ui.methodRec = h('span', { class: 'cl-recnote', hidden: true });
      ui.methodStep = section(0, 'Print method', [ui.methods], ui.methodSub);
      ui.methodStep.querySelector('.cl-step__h').appendChild(ui.methodRec);
      ui.widthStep = section(0, 'Width', [ui.widths]);
    }

    // lanyard color first: everything prints on top of it
    ui.colorName = h('span', { class: 'cl-step__v' });
    ui.colors = h('div', { class: 'cl-swatches', role: 'radiogroup', 'aria-label': 'Lanyard color' }, LANYARD_COLORS.map(function (c) {
      return h('button', { type: 'button', role: 'radio', class: 'cl-sw cl-sw--lanyard', title: c[0], 'aria-label': c[0], 'data-v': c[0], style: 'background:' + c[1], onclick: function () { pickColor(c[0]); } });
    }));
    ui.colorStep = section(2, 'Color', [ui.colors], ui.colorName);

    // artwork: the designer is the default path. Upload / design help sit behind one small toggle
    // at the bottom of the Logo box (after the logo upload, so nobody skips their logo) so they never stand between the customer and the text box (Patrick, 2026-10-13).
    var paths = [['design', "I'll design it here", 'Text, logo, fonts'], ['upload', "I'll upload my completed design", 'PDF, AI, EPS, SVG'], ['help', "I'd like the Specialist ID design team to design it", 'Free, with a proof']];
    ui.paths = h('div', { class: 'cl-paths cl-paths--compact cl-alt__list', role: 'radiogroup', 'aria-label': 'Artwork' }, paths.map(function (p) {
      return h('button', { type: 'button', role: 'radio', class: 'cl-path', 'data-path': p[0], onclick: function () { S.path = p[0]; S.altOpen = p[0] !== 'design'; refreshAll(); } },
        [h('span', { class: 'cl-path__t', text: p[1] }), h('span', { class: 'cl-path__s', text: p[2] })]);
    }));
    ui.altToggle = h('button', { type: 'button', class: 'cl-more', onclick: function () { S.altOpen = !S.altOpen; refreshAll(); } });
    ui.alt = h('div', { class: 'cl-alt' }, [ui.altToggle, ui.paths]);
    ui.design = buildDesignPane();
    ui.upload = buildUploadPane();
    ui.help = buildHelpPane();
    ui.artStep = section(3, 'Custom text & ink', [ui.design, ui.upload, ui.help]);
    ui.logoStep = section(4, 'Logo', [ui.logoPane, ui.alt], h('span', { class: 'cl-step__opt', text: 'optional' }));

    // 3. clip
    ui.clipName = h('span', { class: 'cl-step__v' });
    ui.clips = h('div', { class: 'cl-tiles', role: 'radiogroup', 'aria-label': 'Clip' }, CLIPS.map(function (c, i) {
      return h('button', { type: 'button', role: 'radio', class: 'cl-tile' + (isMain(c[0]) ? '' : ' cl-tile--more'), 'data-v': c[0], title: c[1], onclick: function () { S.clip = c[0]; refreshAll(); } }, [
        h('img', { src: CFG.img[c[0]], alt: '', loading: 'lazy' }),
        h('span', { class: 'cl-tile__txt' }, [h('span', { class: 'cl-tile__n', text: shortClip(c[1], c[0]) }),
          c[2] ? h('span', { class: 'cl-tile__p', text: '+' + money(c[2]) }) : null])
      ]);
    }));
    ui.clipsMore = h('button', { type: 'button', class: 'cl-more', onclick: function () { S.clipsOpen = !S.clipsOpen; refreshAll(); } });
    ui.reelName = h('span', { class: 'cl-step__v' });
    ui.reels = h('div', { class: 'cl-swatches', role: 'radiogroup', 'aria-label': 'Reel color' }, REEL_COLORS.map(function (c) {
      return h('button', { type: 'button', role: 'radio', class: 'cl-sw cl-sw--lanyard', title: c[0], 'aria-label': c[0], 'data-v': c[0], style: 'background:' + c[1], onclick: function () { S.reelColor = c[0]; refreshAll(); } });
    }));
    ui.reelRow = h('div', { class: 'cl-reel' }, [h('div', { class: 'cl-label' }, [document.createTextNode('Reel color '), ui.reelName]), ui.reels]);
    ui.clipStep = section(3, 'Clip', [ui.clips, ui.reelRow, ui.clipsMore], ui.clipName);
    if (new URLSearchParams(location.search).get('layout') !== 'steps') { ui.clipsMore.className = 'cl-tile cl-tile--toggle'; ui.clips.appendChild(ui.clipsMore); }

    // 4. breakaway + finishing
    ui.brkAutoImg = h('img', { alt: '' });
    ui.brks = h('div', { class: 'cl-tiles cl-tiles--2', role: 'radiogroup', 'aria-label': 'Breakaway' }, [
      h('button', { type: 'button', role: 'radio', class: 'cl-tile cl-tile--short', 'data-v': 'none', onclick: function () { S.breakaway = 'none'; refreshAll(); } }, [
        h('span', { class: 'cl-tile__none', 'aria-hidden': 'true' }), h('span', { class: 'cl-tile__n', text: 'None' })]),
      h('button', { type: 'button', role: 'radio', class: 'cl-tile cl-tile--short', 'data-v': 'auto', onclick: function () { S.breakaway = 'auto'; refreshAll(); } }, [
        ui.brkAutoImg, h('span', { class: 'cl-tile__n', text: 'Breakaway' }), ADD_BREAKAWAY ? h('span', { class: 'cl-tile__p', text: '+' + money(ADD_BREAKAWAY) }) : null])
    ]);
    ui.fins = h('div', { class: 'cl-pills', role: 'radiogroup', 'aria-label': 'Finishing' }, FINISHES.map(function (f) {
      return h('button', { type: 'button', role: 'radio', class: 'cl-pill', 'data-v': f[0], onclick: function () { S.finish = f[0]; refreshAll(); }, text: f[0] === 'Crimp' ? 'Metal crimp' : f[0] }); // order value stays Sewn / Crimp
    }));
    ui.brkStep = section(4, 'Breakaway', [ui.brks]);
    ui.endsStep = section(4, 'Strap ends', [ui.fins]);

    // 5. sides
    var sides = [['front', 'Front only', ''], ['same', 'Same on back', ''], ['different', 'Different back', '']];
    ui.sides = h('div', { class: 'cl-pills', role: 'radiogroup', 'aria-label': 'Printed sides' }, sides.map(function (x) {
      return h('button', { type: 'button', role: 'radio', class: 'cl-pill', 'data-v': x[0], onclick: function () { S.sides = x[0]; if (x[0] !== 'different') S.side = 'front'; refreshAll(); } },
        [document.createTextNode(x[1]), x[0] !== 'front' ? h('span', { class: 'cl-pill__p', 'data-back-price': '' }) : null]);
    }));
    ui.sidesStep = section(5, 'Printed sides', [ui.sides]);
    // Order: lanyard color, width (Patrick, 2026-10-13), then artwork (Lars): the logo decides which print method can handle it
    // (woven narrows the colors; a color not offered switches automatically). Was: artwork first - the logo decides which print method can handle it, the
    // method decides the widths and colors on offer - then width, color and the hardware.
    // Three numbered groups, boxes inside unnumbered, printed sides in "Your design" (Patrick approved 2026-10-13).
    // ?layout=steps shows the earlier flat 1-9 list for comparison.
    if (new URLSearchParams(location.search).get('layout') !== 'steps') {
      [['Lanyard', [ui.methodStep, ui.colorStep, ui.widthStep]],
       ['Your design', [ui.artStep, ui.logoStep, ui.sidesStep]],
       ['Hardware', [ui.clipStep, ui.brkStep, ui.endsStep]]].forEach(function (g, i) {
        // the groups carry the numbers (1-3); the boxes inside are unnumbered (Patrick, 2026-10-13)
        card.appendChild(h('h3', { class: 'cl-sect__h' }, [h('span', { class: 'cl-num', 'aria-hidden': 'true', text: String(i + 1) }), h('span', { text: g[0] })]));
        // compact pass (Patrick, 2026-10-13): one card per group; short choices share a row on wide screens
        var gc = h('div', { class: 'cl-gcard' });
        g[1].forEach(function (st) {
          if (!st) return;
          var mate = st === ui.methodStep ? null : st === ui.widthStep ? ui.methodStep : st === ui.endsStep ? ui.brkStep : null;
          if (mate && mate.parentNode === gc) { var pair = h('div', { class: 'cl-pair' }); gc.insertBefore(pair, mate); pair.appendChild(mate); pair.appendChild(st); }
          else gc.appendChild(st);
        });
        card.appendChild(gc);
      });
      card.classList.add('cl-card--groups');
      return card;
    }
    [ui.methodStep, ui.colorStep, ui.widthStep, ui.artStep, ui.logoStep, ui.clipStep, ui.brkStep, ui.endsStep, ui.sidesStep]
      .forEach(function (st) { if (st) card.appendChild(st); });
    return card;
  }
  // tile labels stay short enough for a quarter-width tile; the step label shows the longer name
  var CLIP_SHORT = { sh: 'Swivel hook', sr: 'Split ring', lc: 'Lobster claw', rc: 'Badge reel', ts: 'Trigger snap', pwk: 'Wide plastic hook', pnk: 'Narrow plastic hook',
    pj: 'Plastic J-hook', sv: 'Split ring + strap clip', sb: 'Swivel bulldog', bc: 'Bulldog clip', usb: 'USB holder',
    dh: 'Buckle + swivel hook', dt: 'Buckle + trigger snap', db: 'Buckle + bulldog', dr: 'Buckle + split ring', dlc: 'Buckle + lobster claw', dx: 'Buckle + 3" extension' };
  function shortClip(n, code) { return (code && CLIP_SHORT[code]) || n.replace('Nickel-Plated ', '').replace('Steel ', ''); }

  function buildDesignPane() {
    ui.text = h('input', { type: 'text', class: 'cl-input', maxlength: '40', spellcheck: 'false', autocomplete: 'off', 'aria-label': 'Lanyard text',
      onfocus: function () { if (ui.text.value === DEFAULT_TEXT) ui.text.select(); },
      oninput: function () { cur().text = ui.text.value; var dd = cur(); if (dd.logoSrc && dd.prepKey.split('|')[1] !== (dd.text.trim() ? dd.ink : '')) refreshAll(); else render(); } });
    ui.font = h('select', { class: 'cl-input cl-select', 'aria-label': 'Font', onchange: function () { cur().font = ui.font.value; ensureFont(ui.font.value).then(render); } },
      FONTS.map(function (f) { return h('option', { value: f, text: f }); }));
    ui.logoInput = h('input', { type: 'file', accept: 'image/png,image/jpeg,image/svg+xml,image/webp', class: 'cl-file', onchange: function () { onLogo(ui.logoInput.files[0]); } });
    ui.logoChip = h('span', { class: 'cl-chip' });
    ui.logoBtn = h('button', { type: 'button', class: 'cl-btn', onclick: function () { if (cur().logo) { cur().logo = null; cur().logoImg = null; ui.logoInput.value = ''; refreshAll(); } else ui.logoInput.click(); } });
    ui.inkName = h('span', { class: 'cl-step__v' });
    ui.inks = h('div', { class: 'cl-swatches cl-swatches--ink', role: 'radiogroup', 'aria-label': 'Ink color' }, INK_COLORS.map(function (c) {
      return h('button', { type: 'button', role: 'radio', class: 'cl-sw cl-sw--ink', title: c[0], 'aria-label': c[0], 'data-v': c[0], style: 'background:' + c[1], onclick: function () { cur().ink = c[0]; refreshAll(); } });
    }));
    ui.logoInks = h('span', { class: 'cl-inklist' });
    ui.logoInksRow = h('div', { class: 'cl-sub' }, [h('span', { class: 'cl-label', text: 'Logo prints in' }), ui.logoInks]);
    ui.layout = h('div', { class: 'cl-pills', role: 'radiogroup', 'aria-label': 'Layout' }, [['continuous', 'All one way'], ['mirrored', 'Same both sides']].map(function (l) { // plain-language labels (Patrick); the order still says Continuous / Mirrored
      return h('button', { type: 'button', role: 'radio', class: 'cl-pill', 'data-v': l[0], onclick: function () { S.layout = l[0]; refreshAll(); }, text: l[1] });
    }));
    ui.logoPos = h('div', { class: 'cl-pills', role: 'radiogroup', 'aria-label': 'Logo position' }, [['between', 'Between text'], ['beside', 'Next to text']].map(function (l) {
      return h('button', { type: 'button', role: 'radio', class: 'cl-pill', 'data-v': l[0], onclick: function () { S.logoPos = l[0]; refreshAll(); }, text: l[1] });
    }));
    ui.logoPosRow = h('div', { class: 'cl-sub' }, [h('span', { class: 'cl-label', text: 'Position' }), ui.logoPos]);
    ui.logoAdvice = h('div', { class: 'cl-advice', role: 'status' });
    ui.spacing = h('input', { type: 'range', min: '0.25', max: String(SPACING_MAX), step: '0.25', class: 'cl-range', 'aria-label': 'Space between repeats', oninput: function () { S.spacing = parseFloat(ui.spacing.value); ui.spacingVal.textContent = spacingLabel(); render(); } });
    ui.spacingVal = h('span', { class: 'cl-step__v' });
    // step 3 = text + its color; step 4 = logo (upload, inks, position) + repeat (direction, spacing)
    ui.logoPane = h('div', { class: 'cl-pane' }, [
      h('div', { class: 'cl-drop' }, [ui.logoChip, ui.logoBtn, ui.logoInput]),
      ui.logoInksRow,
      ui.logoAdvice,
      ui.logoPosRow,
      h('div', { class: 'cl-group' }, [
        h('div', { class: 'cl-group__h', text: 'Text direction' }),
        h('div', { class: 'cl-row cl-row--center' }, [ui.layout, h('label', { class: 'cl-field cl-field--range' }, [h('span', { class: 'cl-label' }, [document.createTextNode('Space between repeats '), ui.spacingVal]), ui.spacing])])
      ])
    ]);
    return h('div', { class: 'cl-pane' }, [
      h('div', { class: 'cl-group' }, [
        h('div', { class: 'cl-row' }, [h('label', { class: 'cl-field cl-field--grow' }, [h('span', { class: 'cl-label cl-sr', text: 'Text' }), ui.text]), h('label', { class: 'cl-field' }, [h('span', { class: 'cl-label', text: 'Font' }), ui.font])]),
        h('div', { class: 'cl-sub cl-sub--col' }, [h('span', { class: 'cl-label' }, [document.createTextNode('Ink '), ui.inkName]), ui.inks])
      ])
    ]);
  }
  function buildUploadPane() {
    ui.upInput = h('input', { type: 'file', accept: '.pdf,.ai,.eps,.svg,.png,.jpg,.jpeg,application/pdf,image/svg+xml,application/postscript', class: 'cl-file',
      onchange: function () { S.uploadFile = ui.upInput.files[0] || null; refreshAll(); } });
    ui.upChip = h('span', { class: 'cl-chip' });
    ui.upBtn = h('button', { type: 'button', class: 'cl-btn', onclick: function () { if (S.uploadFile) { S.uploadFile = null; ui.upInput.value = ''; refreshAll(); } else ui.upInput.click(); } });
    return h('div', { class: 'cl-pane' }, [h('div', { class: 'cl-drop' }, [ui.upChip, ui.upBtn, ui.upInput])]);
  }
  function buildHelpPane() {
    ui.notes = h('textarea', { class: 'cl-input', rows: '3', placeholder: 'Company name, colors, where the logo goes', 'aria-label': 'What should it say and look like?',
      oninput: function () { S.helpNotes = ui.notes.value; } });
    ui.helpInput = h('input', { type: 'file', multiple: true, class: 'cl-file', onchange: function () { S.helpFiles = Array.prototype.slice.call(ui.helpInput.files); refreshAll(); } });
    ui.helpChip = h('span', { class: 'cl-chip' });
    ui.helpBtn = h('button', { type: 'button', class: 'cl-btn', onclick: function () { ui.helpInput.click(); } });
    return h('div', { class: 'cl-pane' }, [
      h('label', { class: 'cl-field' }, [h('span', { class: 'cl-label', text: 'What should it say and look like?' }), ui.notes]),
      h('div', { class: 'cl-drop' }, [ui.helpChip, ui.helpBtn, ui.helpInput])
    ]);
  }

  // A lanyard color that hides the ink swaps the two (white ink on navy -> pick white -> navy ink),
  // or falls back to black/white. Picking the ink yourself afterwards is respected.
  function pickColor(name) {
    var prev = S.color; S.color = name;
    ['front', 'back'].forEach(function (k) {
      var d = S.d[k];
      if (Math.abs(lum(hexOf(INK_COLORS, d.ink)) - lum(hexOf(LANYARD_COLORS, name))) >= 0.22 && d.ink !== name) return;
      var swap = INK_COLORS.some(function (c) { return c[0] === prev; }) ? prev : null;
      if (swap && Math.abs(lum(hexOf(INK_COLORS, swap)) - lum(hexOf(LANYARD_COLORS, name))) >= 0.3) d.ink = swap;
      else d.ink = lum(hexOf(LANYARD_COLORS, name)) > 0.55 ? 'Black' : 'White';
    });
    refreshAll();
  }
  function spacingLabel() { return S.spacing >= SPACING_MAX ? 'one per side' : S.spacing + ' in'; }
  function setEngine(key) {
    if (key === S.key) return;
    if (!ENGINES[key]) {
      // keep the method, take the closest width it comes in
      var m = key.replace(/\d+$/, ''), w = key.replace(/^[A-Z]+/, ''), alt = null;
      ['58', '34', '38', '100'].forEach(function (x) { if (!alt && ENGINES[m + x]) alt = m + x; });
      if (!alt) return; key = ENGINES[m + w] ? m + w : alt;
    }
    var apply = function (variants) {
      S.key = key; CFG.variants = variants;
      TIERS = tiersFor(key) || TIERS;
      W_IN = widthIn(); STRIP_H = Math.round(W_IN * PPI);
      refreshAll();
    };
    if (engineCache[key]) return apply(engineCache[key]);
    fetch('/products/' + ENGINES[key] + '.js').then(function (r) { return r.json(); }).then(function (j) {
      engineCache[key] = j.variants.map(function (v) { return { id: v.id, sku: v.sku, price: v.price, clip: v.option1, breakaway: v.option2, sides: v.option3 }; });
      apply(engineCache[key]);
    }).catch(function () { flash('That option could not be loaded. Please try again.'); });
  }
  function cur() { return S.d[S.sides === 'different' ? S.side : 'front']; }
  function setSide(side) { S.side = side; refreshAll(); }

  function onLogo(file) {
    if (!file) return;
    if (/heic|heif/i.test(file.type) || /\.hei[cf]$/i.test(file.name)) { flash('HEIC photos can\'t be read here. Save it as PNG or JPG and try again.'); return; }
    var d = cur(), url = URL.createObjectURL(file);
    loadImg(url).then(function (img) {
      if (!img) { flash('That file couldn\'t be read. Try a PNG, JPG or SVG.'); return; }
      d.logo = file; d.logoSrc = img; d.prepKey = ''; d.logoInfo = analyzeLogo(img); refreshAll();
    });
  }
  function flash(msg) { ui.err.textContent = msg; }

  /* ---------- silk screen / woven logo: solid inks only ----------
     Silk screen prints each color through its own screen as a solid PMS ink: no gradients, photos
     or semi-transparency, and our lanyards take up to 3 inks in total (text included). So the logo is
     cut out of its background (only what touches the edges, so white inside a logo still prints),
     reduced to its main colors, and each one snapped to the nearest ink on our chart. Woven uses solid
     thread colors the same way. Dye sublimation prints the logo as is. */
  var MAX_INKS = 3;
  function hexRgb(h) { var n = parseInt(h.slice(1), 16); return [n >> 16, (n >> 8) & 255, n & 255]; }
  function dist2(a, b) { var dr = a[0] - b[0], dg = a[1] - b[1], db = a[2] - b[2]; return 2 * dr * dr + 4 * dg * dg + 3 * db * db; }
  function nearestInk(rgb) {
    var best = null, bd = 1e12;
    INK_COLORS.forEach(function (c) { var d = dist2(rgb, hexRgb(c[1])); if (d < bd) { bd = d; best = c; } });
    return best;
  }
  function reduceLogo(img, textInk, size) {
    var M = size || 512, sc = Math.min(1, M / Math.max(img.width, img.height));
    var w = Math.max(1, Math.round(img.width * sc)), hgt = Math.max(1, Math.round(img.height * sc));
    var c = document.createElement('canvas'); c.width = w; c.height = hgt;
    var x = c.getContext('2d'); x.drawImage(img, 0, 0, w, hgt);
    var id = x.getImageData(0, 0, w, hgt), px = id.data, N = w * hgt, i;
    // 1. background: the color around the border, flood-filled in from the edges only
    var border = [];
    for (i = 0; i < w; i++) { border.push(i, (hgt - 1) * w + i); }
    for (i = 0; i < hgt; i++) { border.push(i * w, i * w + w - 1); }
    var opaqueBorder = border.filter(function (k) { return px[k * 4 + 3] > 200; });
    if (opaqueBorder.length > border.length * 0.6) {
      var acc = [0, 0, 0]; opaqueBorder.forEach(function (k) { acc[0] += px[k * 4]; acc[1] += px[k * 4 + 1]; acc[2] += px[k * 4 + 2]; });
      var bg = acc.map(function (v) { return v / opaqueBorder.length; }), tol = 2 * 38 * 38 + 4 * 38 * 38 + 3 * 38 * 38;
      var seen = new Uint8Array(N), stack = border.slice();
      while (stack.length) {
        var k = stack.pop(); if (seen[k]) continue; seen[k] = 1;
        if (dist2([px[k * 4], px[k * 4 + 1], px[k * 4 + 2]], bg) > tol) continue;
        px[k * 4 + 3] = 0;
        var xx = k % w, yy = (k / w) | 0;
        if (xx > 0) stack.push(k - 1); if (xx < w - 1) stack.push(k + 1); if (yy > 0) stack.push(k - w); if (yy < hgt - 1) stack.push(k + w);
      }
    }
    // 2. main colors (k-means on opaque pixels)
    function cluster(kN) {
      var pts = [], step = Math.max(1, Math.floor(N / 20000));
      for (i = 0; i < N; i += step) if (px[i * 4 + 3] >= 128) pts.push([px[i * 4], px[i * 4 + 1], px[i * 4 + 2]]);
      if (!pts.length) return [];
      var cs = [pts[Math.floor(pts.length / 2)]];
      while (cs.length < kN) { // farthest-point seeding
        var far = null, fd = -1;
        pts.forEach(function (p) { var d = Math.min.apply(null, cs.map(function (cc) { return dist2(p, cc); })); if (d > fd) { fd = d; far = p; } });
        if (fd < 2000) break; cs.push(far.slice());
      }
      for (var it = 0; it < 10; it++) {
        var sum = cs.map(function () { return [0, 0, 0, 0]; });
        pts.forEach(function (p) { var bi = 0, bd = 1e12; cs.forEach(function (cc, j) { var d = dist2(p, cc); if (d < bd) { bd = d; bi = j; } }); var t = sum[bi]; t[0] += p[0]; t[1] += p[1]; t[2] += p[2]; t[3]++; });
        cs = sum.filter(function (t) { return t[3] > pts.length * 0.01; }).map(function (t) { return [t[0] / t[3], t[1] / t[3], t[2] / t[3]]; });
      }
      return cs;
    }
    function inksFor(kN) {
      var list = [];
      cluster(kN).forEach(function (cc) { var ink = nearestInk(cc); if (list.indexOf(ink) < 0) list.push(ink); });
      return list;
    }
    var inks = inksFor(MAX_INKS);
    // the text ink counts toward the 3: if it isn't already one of the logo's inks, the logo gets 2
    var tInk = textInk && INK_COLORS.filter(function (cc) { return cc[0] === textInk; })[0];
    if (tInk && inks.length >= MAX_INKS && inks.indexOf(tInk) < 0) inks = inksFor(MAX_INKS - 1);
    // 3. repaint: every opaque pixel becomes its nearest chosen ink, fully solid
    var rgbs = inks.map(function (cc) { return hexRgb(cc[1]); });
    for (i = 0; i < N; i++) {
      var o = i * 4;
      if (px[o + 3] < 128 || !rgbs.length) { px[o + 3] = 0; continue; }
      var p = [px[o], px[o + 1], px[o + 2]], bj = 0, bd2 = 1e12;
      rgbs.forEach(function (r, j) { var d = dist2(p, r); if (d < bd2) { bd2 = d; bj = j; } });
      px[o] = rgbs[bj][0]; px[o + 1] = rgbs[bj][1]; px[o + 2] = rgbs[bj][2]; px[o + 3] = 255;
    }
    var mask = new Uint8Array(N); for (i = 0; i < N; i++) mask[i] = px[i * 4 + 3] > 0 ? 1 : 0;
    x.putImageData(id, 0, 0);
    return { canvas: c, inks: inks.map(function (cc) { return cc[0]; }), mask: mask };
  }
  // How demanding is the logo? Counts its real colors (clusters of 3%+ of the logo) and how many
  // distinct shades it uses (shading, photos, gradients, anti-aliased detail). Silk screen and woven
  // print solid inks only; dye sublimation prints anything.
  function analyzeLogo(img) {
    var M = 160, sc = Math.min(1, M / Math.max(img.width, img.height));
    var w = Math.max(1, Math.round(img.width * sc)), hgt = Math.max(1, Math.round(img.height * sc));
    var r = reduceLogo(img, null, M);                     // reuse the background cut-out at the same small size
    var c = document.createElement('canvas'); c.width = w; c.height = hgt;
    var x = c.getContext('2d'); x.drawImage(img, 0, 0, w, hgt);
    var px = x.getImageData(0, 0, w, hgt).data, mask = r.mask, i, pts = [], shades = {};
    for (i = 0; i < w * hgt; i++) if (mask[i]) { var p = [px[i * 4], px[i * 4 + 1], px[i * 4 + 2]]; pts.push(p); shades[(p[0] >> 4) + ',' + (p[1] >> 4) + ',' + (p[2] >> 4)] = 1; }
    if (!pts.length) return { colors: 0, complex: false };
    // count colors: greedy clustering with a perceptual-ish radius
    var cl = [];
    pts.forEach(function (p) { for (var j = 0; j < cl.length; j++) if (dist2(p, cl[j].c) < 9000) { cl[j].n++; return; } cl.push({ c: p, n: 1 }); });
    var colors = cl.filter(function (q) { return q.n >= pts.length * 0.03; }).length;
    var nShades = Object.keys(shades).length;
    return { colors: colors, shades: nShades, complex: colors > MAX_INKS || nShades > 90 };
  }
  function renderAdvice(d) {
    var info = d.logo && d.logoInfo, m = method(), box = ui.logoAdvice;
    box.innerHTML = ''; box.hidden = true;
    if (ui.methods) Array.prototype.forEach.call(ui.methods.children, function (b) {
      // the recommendation lives in the label row (a pill) and as a dot on the button; a tag on the
      // button's edge no longer fits the slim bars (Patrick, 2026-10-13)
      var rec = !!info && b.getAttribute('data-v') === (info.complex ? 'DS' : 'SS');
      b.classList.toggle('is-rec', rec); if (rec) b.title = 'Recommended for your logo'; else b.removeAttribute('title');
    });
    if (ui.methodRec) {
      ui.methodRec.hidden = !info;
      if (info) ui.methodRec.textContent = 'Suits your logo: ' + (info.complex ? 'Dye sub' : 'Silk screen');
      if (ui.methodSub) ui.methodSub.hidden = !!info; // one note at a time keeps the label on one line
    }
    if (!info) return;
    var why = info.colors > MAX_INKS ? info.colors + ' colors' : 'shading or fine detail';
    if (info.complex && m !== 'DS') {
      box.hidden = false;
      box.appendChild(h('p', { text: 'Your logo has ' + why + '. ' + METHODS[m].name + ' prints it in up to 3 solid colors, as shown. Dye sublimation prints it in full color.' }));
      if (FULL && ENGINES['DS' + widthCode()]) box.appendChild(h('button', { type: 'button', class: 'cl-btn', onclick: function () { setEngine('DS' + widthCode()); }, text: 'Switch to dye sublimation' }));
      else if (CFG.fullUrl) box.appendChild(h('a', { class: 'cl-btn', href: CFG.fullUrl + (CFG.fullUrl.indexOf('?') < 0 ? '?' : '&') + 'print=DS', text: 'Design it in full color' }));
    } else if (!info.complex && m === 'DS' && FULL && ENGINES['SS' + widthCode()]) {
      box.hidden = false;
      box.appendChild(h('p', { text: 'Your logo has ' + info.colors + (info.colors === 1 ? ' color' : ' colors') + ', so silk screen can print it for less.' }));
      box.appendChild(h('button', { type: 'button', class: 'cl-btn', onclick: function () { setEngine('SS' + widthCode()); }, text: 'Switch to silk screen' }));
    }
  }
  function prepLogo(d) {
    if (!d.logoSrc) { d.logoImg = null; d.logoInkList = null; return; }
    var solid = method() !== 'DS', key = method() + '|' + (d.text.trim() ? d.ink : '');
    if (d.prepKey === key) return;
    d.prepKey = key;
    if (!solid) { d.logoImg = d.logoSrc; d.logoInkList = null; return; }
    var r = reduceLogo(d.logoSrc, d.text.trim() ? d.ink : null);
    d.logoImg = r.canvas; d.logoInkList = r.inks;
  }

  function setOn(container, val) {
    Array.prototype.forEach.call(container.children, function (b) {
      var on = b.getAttribute('data-v') === String(val) || b.getAttribute('data-path') === String(val);
      b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function refreshAll() {
    var m = method();
    if (FULL && ui.widths) {
      Array.prototype.forEach.call(ui.widths.children, function (b) {
        var ok = !!ENGINES[m + b.getAttribute('data-v')]; b.disabled = !ok; b.title = ok ? '' : 'Not available in ' + METHODS[m].name.toLowerCase();
        var on = b.getAttribute('data-v') === widthCode(); b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      Array.prototype.forEach.call(ui.methods.children, function (b) {
        var mm = b.getAttribute('data-v'), ok = !!ENGINES[mm + widthCode()] || WIDTHS.some(function (w) { return ENGINES[mm + w[0]]; });
        b.disabled = !ok; var on = mm === m; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (ui.methodSub) ui.methodSub.textContent = METHODS[m].sub;
    }
    if (m === 'WV') { S.sides = 'front'; S.side = 'front'; }
    if (ui.sidesStep) ui.sidesStep.hidden = m === 'WV';
    Array.prototype.forEach.call(document.querySelectorAll('[data-back-price]'), function (el) { el.textContent = addBack() ? ' +' + money(addBack()) : ''; });
    if (m !== 'DS' && STD_COLORS.indexOf(S.color) < 0) S.color = 'Black';
    Array.prototype.forEach.call(ui.colors.children, function (b) { b.hidden = m !== 'DS' && STD_COLORS.indexOf(b.getAttribute('data-v')) < 0; });
    Array.prototype.forEach.call(ui.inks.children, function (b) { b.hidden = m === 'WV' && WOVEN_COLORS.indexOf(b.getAttribute('data-v')) < 0; });
    var d = cur();
    setOn(ui.paths, S.path);
    var altOpen = S.altOpen || S.path !== 'design';
    ui.paths.hidden = !altOpen; ui.altToggle.setAttribute('aria-expanded', altOpen ? 'true' : 'false');
    ui.altToggle.innerHTML = 'Already have a finished design, or want us to design it? <span class="cl-chev" aria-hidden="true"></span>';
    // the Logo box hides on the upload / design-help paths, so the toggle moves up into step 1 there
    var altHome = S.path === 'design' ? ui.logoStep : ui.artStep; if (altHome && ui.alt.parentNode !== altHome) altHome.appendChild(ui.alt);
    ui.design.hidden = S.path !== 'design'; if (ui.logoStep) ui.logoStep.hidden = S.path !== 'design';
    // number the visible steps 1, 2, 3... (the logo step hides on the upload / design-help paths)
    var n = 0; if (!ui.card.classList.contains('cl-card--groups')) Array.prototype.forEach.call(ui.card.querySelectorAll('.cl-step'), function (st) { if (!st.hidden) { var num = st.querySelector('.cl-num'); if (num) num.textContent = String(++n); } });
    // the text box and ink swatches speak for themselves: no heading on the designer path (Patrick); 'Your artwork' on upload / help
    if (ui.artStep) { var ah = ui.artStep.querySelector('.cl-step__h'); ah.hidden = S.path === 'design' && ui.card.classList.contains('cl-card--groups'); ah.querySelector('span:not(.cl-num)').textContent = S.path === 'design' ? 'Custom text & ink' : 'Your artwork'; } ui.upload.hidden = S.path !== 'upload'; ui.help.hidden = S.path !== 'help';
    ui.text.value = d.text; ui.font.value = d.font;
    ui.logoChip.textContent = d.logo ? d.logo.name : 'PNG, JPG or SVG';
    ui.logoBtn.textContent = d.logo ? 'Remove' : 'Upload logo';
    prepLogo(S.d.front); prepLogo(S.d.back);
    renderAdvice(d);
    ui.logoInksRow.hidden = !d.logo || !d.logoInkList;
    ui.logoInks.innerHTML = '';
    (d.logoInkList || []).forEach(function (n) { ui.logoInks.appendChild(h('span', { class: 'cl-inkchip' }, [h('span', { class: 'cl-inkchip__sw', style: 'background:' + hexOf(INK_COLORS, n) }), document.createTextNode(n)])); });
    setOn(ui.inks, d.ink); ui.inkName.textContent = d.ink;
    setOn(ui.logoPos, S.logoPos); ui.logoPosRow.hidden = !(d.logo && d.text.trim());
    setOn(ui.layout, S.layout); ui.spacing.value = S.spacing; ui.spacingVal.textContent = spacingLabel();
    ui.upChip.textContent = S.uploadFile ? S.uploadFile.name : 'Print-ready file built at full size';
    ui.upBtn.textContent = S.uploadFile ? 'Remove' : 'Choose file';
    ui.helpChip.textContent = S.helpFiles.length ? S.helpFiles.map(function (f) { return f.name; }).join(', ') : 'Logo, sketch or photo (optional)';
    ui.helpBtn.textContent = S.helpFiles.length ? 'Change files' : 'Choose files';
    setOn(ui.colors, S.color); ui.colorName.textContent = S.color;
    setOn(ui.clips, S.clip); ui.clipName.textContent = shortClip(clipBy(S.clip)[1]);
    ui.reelRow.hidden = S.clip !== 'rc'; setOn(ui.reels, reelColor()); ui.reelName.textContent = reelColor();
    ui.clips.classList.toggle('is-open', !!S.clipsOpen);
    ui.clipsMore.setAttribute('aria-expanded', S.clipsOpen ? 'true' : 'false');
    ui.clipsMore.innerHTML = ui.clipsMore.classList.contains('cl-tile--toggle')
      ? '<span class="cl-tile__n">' + (S.clipsOpen ? 'Fewer' : (CLIPS.length - MAIN_CLIPS.length) + ' more') + '</span>'
      : (S.clipsOpen ? 'Fewer clips' : 'More clips (' + (CLIPS.length - MAIN_CLIPS.length) + ')') + ' <span class="cl-chev" aria-hidden="true"></span>';
    // collapsed: a clip picked from the full list moves to the front of the short row
    var picked = !isMain(S.clip) && !S.clipsOpen;
    Array.prototype.forEach.call(ui.clips.children, function (t) {
      var code = t.getAttribute('data-v');
      t.classList.toggle('cl-tile--picked', picked && code === S.clip);
      t.style.order = picked && code === S.clip ? '-1' : '';
      // keep the short row at three: the picked clip + the top two
      t.classList.toggle('cl-tile--bumped', picked && code === MAIN_CLIPS[MAIN_CLIPS.length - 1]);
    });
    if (S.breakaway !== 'none') S.breakaway = 'auto'; // only None / Breakaway offered; black or white follows the lanyard
    setOn(ui.brks, S.breakaway); setOn(ui.fins, S.finish);
    ui.brkAutoImg.src = CFG.img['brk-' + autoBrk()];
    setOn(ui.sides, S.sides);
    ui.sideTabs.hidden = S.sides !== 'different';
    Array.prototype.forEach.call(ui.sideTabs.children, function (b) { b.classList.toggle('is-on', b.getAttribute('data-side') === S.side); });
    ui.err.textContent = '';
    setVariant();
    updatePrice();
    render();
  }

  function setVariant() {
    var v = currentVariant(); if (!v) return;
    var input = ui.form.querySelector('input[name="id"], select[name="id"]');
    if (input && String(input.value) !== String(v.id)) { input.value = v.id; input.dispatchEvent(new Event('change', { bubbles: true })); }
    // the 2026 buy box prints "Part # ..." beside the stars; keep it on the chosen variant
    var pn = document.querySelectorAll('[data-bb-sku]');
    Array.prototype.forEach.call(pn, function (el) { el.textContent = v.sku || ''; });
    ui.sku.hidden = pn.length > 0;
    ui.sku.textContent = 'Part # ' + (v.sku || '');
  }

  function updatePrice() {
    var q = qty(), u = unitAt(q); if (u == null) return;
    ui.price.innerHTML = '';
    ui.price.appendChild(h('span', { class: 'cl-price__v', text: money(u) }));
    ui.price.appendChild(h('span', { class: 'cl-price__ea', text: 'each' }));
    var v = currentVariant(), list = v.price / 100, base100 = TIERS[0].base, cur = 0;
    TIERS.forEach(function (t, i) { if (q >= t.q) cur = i; });
    ui.tiers.innerHTML = '';
    var labQ = h('div', { class: 'cl-tiers__lab' }, [h('span', { text: 'Qty' }), h('span', { text: 'Each' })]);
    var grid = h('div', { class: 'cl-tiers__grid' }, TIERS.map(function (t, i) {
      return h('button', { type: 'button', class: 'cl-tier' + (i === cur ? ' is-on' : ''), onclick: function () { setQty(t.q); } }, [
        h('span', { class: 'cl-tier__q', text: (i === TIERS.length - 1 ? t.q.toLocaleString('en-US') + '+' : t.q.toLocaleString('en-US')) }),
        h('span', { class: 'cl-tier__p', text: money(Math.max(0, list - (base100 - t.base))) })
      ]);
    }));
    ui.tiers.appendChild(labQ); ui.tiers.appendChild(grid);
    ui.total.innerHTML = '';
    ui.total.appendChild(h('strong', { class: 'cl-total__l', text: 'Total' }));
    ui.total.appendChild(h('span', { class: 'cl-total__x', text: q.toLocaleString('en-US') + ' × ' + money(u) }));
    ui.total.appendChild(h('span', { class: 'cl-total__v', text: money(u * q) }));
    // next-tier nudge; when the next break costs less in total than this quantity, say so (no tier cliffs)
    var nx = TIERS[cur + 1], nu = nx ? Math.max(0, list - (base100 - nx.base)) : 0;
    ui.next.textContent = !nx ? '' : nx.q * nu <= u * q
      ? nx.q.toLocaleString('en-US') + ' cost ' + money(nx.q * nu) + ' (' + money(nu) + ' each), less than your ' + q.toLocaleString('en-US')
      : (nx.q - q) <= Math.max(50, nx.q * 0.25) ? 'Add ' + (nx.q - q).toLocaleString('en-US') + ' more for ' + money(nu) + ' each' : '';
  }
  function setQty(n) {
    var q = document.querySelector('input[name="quantity"]'); if (!q) return;
    q.value = n; q.dispatchEvent(new Event('change', { bubbles: true })); updatePrice();
  }

  /* ---------- render ---------- */
  var renderToken = 0;
  function render() {
    var token = ++renderToken;
    var face = S.sides === 'different' ? S.side : 'front';
    var d = S.d[face];
    ensureFont(d.font).then(function () {
      if (token !== renderToken) return;
      var sc = Math.min(4, 2 * S.view.z), strip = buildStrip(face, { scale: sc });
      var view = drawHanging(ui.hang, strip, { z: S.view.z, x: S.view.x, y: S.view.y, back: backStrip(sc, face) });
      if (ui.rail && !ui.photo.hidden) showPhoto(null);
      drawHardware(view);
      drawCloseup(ui.close, strip); bindCloseDrag(ui.close);
      ui.zoomReset.hidden = S.view.z === 1 && !S.view.x && !S.view.y;
      markDirty();
    });
  }

  /* ---------- thumbnail rail (server-rendered #clThumbs, under the stage) ---------- */
  function mountRail() {
    var rail = document.getElementById('clThumbs');
    if (!rail) return;
    ui.rail = rail; rail.hidden = false;
    ui.stage.after(rail);
    rail.addEventListener('click', function (e) {
      var t = e.target.closest('.cl-thumb'); if (!t) return;
      showPhoto(t.getAttribute('data-full'), t);
    });
  }
  function showPhoto(src, tile) {
    ui.photo.hidden = !src; ui.hang.hidden = !!src;
    ui.stage.classList.toggle('is-photo', !!src);
    if (src) ui.photo.src = src;
    if (ui.rail) Array.prototype.forEach.call(ui.rail.querySelectorAll('.cl-thumb'), function (t) {
      t.classList.toggle('is-active', src ? t === tile : t.classList.contains('cl-thumb--design'));
    });
  }

  /* ---------- zoom + pan on the preview ---------- */
  var ZMIN = 1, ZMAX = 6;
  function clampView() {
    var v = S.view; v.z = Math.max(ZMIN, Math.min(ZMAX, v.z));
    var mx = VIEW_W / 2 * (v.z - 1), my = VIEW_H / 2 * (v.z - 1);
    v.x = Math.max(-mx, Math.min(mx, v.x)); v.y = Math.max(-my, Math.min(my, v.y));
    if (v.z === 1) { v.x = 0; v.y = 0; }
  }
  // zoom keeping the point under (px, py) (view units) where it is
  function zoomAt(f, px, py) {
    var v = S.view, z2 = Math.max(ZMIN, Math.min(ZMAX, v.z * f)), k = z2 / v.z;
    var cx = VIEW_W / 2, cy = VIEW_H / 2;
    v.x = (px - cx) * (1 - k) + k * v.x; v.y = (py - cy) * (1 - k) + k * v.y; v.z = z2;
    clampView(); scheduleRender();
  }
  function zoomBy(f) { zoomAt(f, VIEW_W / 2, VIEW_H / 2); }
  var rafPending = false;
  function scheduleRender() { if (rafPending) return; rafPending = true; requestAnimationFrame(function () { rafPending = false; render(); }); }
  function bindZoom(cv) {
    function toView(e) { var r = cv.getBoundingClientRect(); return { x: (e.clientX - r.left) * VIEW_W / r.width, y: (e.clientY - r.top) * VIEW_H / r.height, k: VIEW_W / r.width }; }
    cv.addEventListener('wheel', function (e) {
      // zooming out at full size lets the page scroll on
      if (e.deltaY > 0 && S.view.z <= ZMIN) return;
      e.preventDefault();
      var p = toView(e); zoomAt(Math.exp(-e.deltaY * 0.0015), p.x, p.y);
    }, { passive: false });
    var pts = {}, last = null, pinch = null;
    cv.addEventListener('pointerdown', function (e) { cv.setPointerCapture(e.pointerId); pts[e.pointerId] = toView(e); last = pts[e.pointerId]; cv.classList.add('is-grabbing'); });
    cv.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      var p = toView(e), ids = Object.keys(pts);
      if (ids.length === 2) {
        pts[e.pointerId] = p;
        var a = pts[ids[0]], b = pts[ids[1]], d = Math.hypot(a.x - b.x, a.y - b.y);
        if (pinch) zoomAt(d / pinch, (a.x + b.x) / 2, (a.y + b.y) / 2);
        pinch = d; return;
      }
      if (S.view.z > 1) { S.view.x += p.x - pts[e.pointerId].x; S.view.y += p.y - pts[e.pointerId].y; clampView(); scheduleRender(); e.preventDefault(); }
      pts[e.pointerId] = p;
    });
    function up(e) { delete pts[e.pointerId]; pinch = null; if (!Object.keys(pts).length) cv.classList.remove('is-grabbing'); }
    cv.addEventListener('pointerup', up); cv.addEventListener('pointercancel', up);
    cv.addEventListener('dblclick', function (e) { if (S.view.z > 1) { S.view = { z: 1, x: 0, y: 0 }; render(); } else { var p = toView(e); zoomAt(2.5, p.x, p.y); } });
  }

  /* ---------- order payload ---------- */
  var dirty = true, attaching = null, okToSubmit = false;
  function markDirty() { dirty = true; }
  function hidden(name, type) {
    var el = ui.form.querySelector('[data-cl="' + name + '"]');
    if (!el) { el = h('input', { type: type || 'hidden', name: 'properties[' + name + ']', 'data-cl': name, hidden: true, class: 'cl-file' }); ui.form.appendChild(el); }
    return el;
  }
  function clearProps() { Array.prototype.forEach.call(ui.form.querySelectorAll('[data-cl]'), function (el) { el.remove(); }); }
  function setFile(name, file) { var el = hidden(name, 'file'); var dt = new DataTransfer(); dt.items.add(file); el.files = dt.files; }
  function setVal(name, val) { if (val === '' || val == null) return; hidden(name).value = val; }
  function canvasBlob(c) { return new Promise(function (res) { c.toBlob(function (b) { res(b); }, 'image/png'); }); }

  function validate() {
    var q = qty();
    if (q < CFG.minQty) return 'The minimum is ' + CFG.minQty + ' lanyards.';
    if (S.path === 'design') {
      var f = S.d.front;
      if (!f.text.trim() && !f.logo) return 'Add your text or logo.';
      if (f.text.trim().toLowerCase() === DEFAULT_TEXT.toLowerCase()) return 'Replace "' + DEFAULT_TEXT + '" with your own text.';
      if (S.sides === 'different') { var b = S.d.back; if (!b.text.trim() && !b.logo) return 'Add text or a logo for the back, or pick "Same on back".'; }
    }
    if (S.path === 'upload' && !S.uploadFile) return 'Choose your artwork file.';
    if (S.path === 'help' && !S.helpNotes.trim() && !S.helpFiles.length) return 'Tell us what you want, or attach a file.';
    return '';
  }

  function attachAll() {
    var jobs0 = [];
    clearProps();
    var f = S.d.front, b = S.d.back, brk = brkBy(effBreakaway());
    var artLabel = { design: 'Designed online', upload: 'Print-ready file', help: 'Design help requested' }[S.path];
    setVal('Artwork', artLabel);
    setVal('Lanyard color', S.color);
    setVal('Imprint', METHODS[method()].label + ', ' + widthLabel());
    if (S.path === 'design') {
      setVal('Text', f.text.trim()); if (f.text.trim()) setVal('Font', f.font);
      setVal('Text color', f.ink);
      if (f.logo && f.logoInkList) { setVal('Logo inks', f.logoInkList.join(', ')); }
      var allInks = (f.logoInkList || []).slice(); if (f.text.trim() && allInks.indexOf(f.ink) < 0) allInks.push(f.ink);
      if (method() !== 'DS') setVal('Ink colors', String(allInks.length));
      setVal('Layout', S.layout === 'mirrored' ? 'Mirrored' : 'Continuous');
      if (f.logo && f.text.trim()) setVal('Logo position', S.logoPos === 'between' ? 'Between text' : 'Next to text');
      setVal('Spacing', spacingLabel());
    }
    if (S.clip === 'rc') setVal('Reel color', reelColor());
    setVal('Breakaway style', brk[1]);
    setVal('Finishing', S.finish);
    setVal('Back', { front: 'Blank', same: 'Same as front', different: 'Different design' }[S.sides]);
    if (S.path === 'design' && S.sides === 'different') {
      setVal('Back text', b.text.trim()); if (b.text.trim()) setVal('Back font', b.font);
      setVal('Back text color', b.ink);
    }
    if (S.path === 'help') setVal('Design notes', S.helpNotes.trim());
    hidden('_Design').value = JSON.stringify({
      v: 1, product: 'lanyard', method: METHODS[method()].label, engine: S.key, width_in: W_IN, length_in: LEN_IN, ppi: PPI, path: S.path,
      color: S.color, clip: clipBy(S.clip)[1], reel_color: S.clip === 'rc' ? reelColor() : null, breakaway: brk[1], finishing: S.finish, sides: S.sides,
      layout: S.layout, logo_position: S.logoPos, spacing_in: S.spacing, noprint_end_in: NOPRINT_END_IN, single_per_side: S.spacing >= SPACING_MAX, breakaway_clear_in: S.breakaway !== 'none' ? BREAKAWAY_CLEAR_IN : 0,
      front: { text: f.text.trim(), font: f.font, ink: f.ink, logo: !!f.logo, logo_inks: f.logoInkList },
      back: S.sides === 'different' ? { text: b.text.trim(), font: b.font, ink: b.ink, logo: !!b.logo, logo_inks: b.logoInkList } : null
    });
    if (S.path === 'design' && f.logo) setFile('_Artwork', f.logo);
    if (S.path === 'design' && f.logoInkList && f.logoImg && f.logoImg.toBlob) jobs0.push(canvasBlob(f.logoImg).then(function (bl) { if (bl) setFile('_Logo inks', new File([bl], 'logo-' + f.logoInkList.length + '-inks.png', { type: 'image/png' })); }));
    if (S.path === 'design' && S.sides === 'different' && b.logo) setFile('_Artwork Back', b.logo);
    if (S.path === 'upload' && S.uploadFile) setFile('_Artwork', S.uploadFile);
    if (S.path === 'help' && S.helpFiles[0]) setFile('_Artwork', S.helpFiles[0]);

    var proofCv = document.createElement('canvas');
    var proofView = drawHanging(proofCv, buildStrip('front', { scale: 2 }), { z: 1, x: 0, y: 0, back: backStrip(2, 'front') });
    var jobs = [drawHardware(proofView).then(function () { return canvasBlob(proofCv); }).then(function (blob) { if (blob) setFile('_Proof', new File([blob], 'lanyard-proof.png', { type: 'image/png' })); })];
    jobs = jobs0.concat(jobs);
    if (S.path === 'design') {
      jobs.push(canvasBlob(buildStrip('front', { scale: 150 / PPI, flat: true })).then(function (blob) { if (blob) setFile('_Print strip', new File([blob], 'lanyard-print-front.png', { type: 'image/png' })); }));
      if (S.sides === 'different') jobs.push(canvasBlob(buildStrip('back', { scale: 150 / PPI, flat: true })).then(function (blob) { if (blob) setFile('_Print strip Back', new File([blob], 'lanyard-print-back.png', { type: 'image/png' })); }));
    }
    return Promise.all(jobs);
  }

  function onSubmit(e) {
    if (!ui.form || e.target !== ui.form) return;
    if (okToSubmit) { okToSubmit = false; return; }
    e.preventDefault(); e.stopImmediatePropagation();
    var msg = validate();
    if (msg) { ui.err.textContent = msg; ui.err.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
    ui.err.textContent = '';
    if (attaching) return;
    var face = S.sides === 'different' ? S.side : 'front';
    var redraw = face === 'front' ? Promise.resolve() : (S.side = 'front', new Promise(function (r) { refreshAll(); setTimeout(r, 400); }));
    attaching = redraw.then(attachAll).then(function () {
      attaching = null; okToSubmit = true;
      if (ui.form.requestSubmit) ui.form.requestSubmit(); else ui.form.submit();
    }).catch(function () { attaching = null; ui.err.textContent = 'Something went wrong preparing your design. Please try again.'; });
  }

  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
